/**
 * Generated by Orval
 * Do not edit manually.
 * Sell To API
 * OpenAPI spec version: v3
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery,
  useSuspenseInfiniteQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  InvalidateOptions,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseInfiniteQueryOptions,
  UseSuspenseInfiniteQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  AddQuotationObservationDocumentRequest,
  AwardQuotationOfferRequest,
  CancelNegotiationLegacyRequest,
  CancelNegotiationRequest,
  CancelOrRecreateQuotationRequest,
  ChangeAssignedUserLegacyRequest,
  ChangeQuotationThreatRequest,
  ChangeThreatClassificationRequest,
  CloseRenegotiationLegacyRequest,
  CloseRenegotiationRequest,
  CreateValidationQuotationsRequest,
  EnsureQuotationChatsRequest,
  EnsureQuotationNegotiationChatRequest,
  EntitiesQuotationCollectionApprovalStats,
  EntitiesQuotationCollectionListResponse,
  EntitiesQuotationCollectionMassReopenResponse,
  EntitiesQuotationCollectionPurchaseOrderPreviewItem,
  EntitiesQuotationCollectionValidationResult,
  EntitiesQuotationMemberActionResult,
  EntitiesQuotationMemberActivity,
  EntitiesQuotationMemberAllowedActions,
  EntitiesQuotationMemberAssignableUserListResponse,
  EntitiesQuotationMemberChatListResponse,
  EntitiesQuotationMemberDoubtsListResponse,
  EntitiesQuotationMemberFilesResponse,
  EntitiesQuotationMemberMain,
  EntitiesQuotationMemberOffersCollectionActionResult,
  EntitiesQuotationMemberOffersCollectionMain,
  EntitiesQuotationMemberOffersMemberActionResult,
  EntitiesQuotationMemberOpenDoubts,
  EntitiesQuotationMemberSearchVendorsListResponse,
  FinishRenegotiationLegacyRequest,
  FinishRenegotiationRequest,
  GetApprovalStatisticsParams,
  GetQuotationsForIssuePurchaseOrderParams,
  InviteVendorsToQuotationRequest,
  ListQuotationAssignableUsersParams,
  ListQuotationChatsParams,
  ListQuotationDoubtsParams,
  ListQuotationNegotiationChatsParams,
  ListQuotationsParams,
  MassReopenOfferWindowRequest,
  OpenToRenegotiationLegacyRequest,
  OpenToRenegotiationRequest,
  PurchaseOrderPreviewParams,
  RefuseQuotationRequest,
  ReopenOfferWindowLegacyRequest,
  ReopenOfferWindowRequest,
  RequestAnticipationEvaluationLegacyRequest,
  RequestAnticipationEvaluationRequest,
  SearchQuotationVendorsParams,
  UpdateAssignedUserRequest,
  UpdateQuotationObservationRequest
} from '../../models';

import { customInstance } from '../../../../services/api';
import type { ErrorType } from '../../../../services/api';
import { customQueryOptions } from '../../../../mutators/customQueryOptions';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * @summary List of quotations
 */
export const listQuotations = (
    params?: ListQuotationsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<EntitiesQuotationCollectionListResponse>(
      {url: `/api/v3/quotations`, method: 'GET',
        params, signal
    },
      options);
    }




export const getListQuotationsInfiniteQueryKey = (params?: ListQuotationsParams,) => {
    return [
    'infinite', `/api/v3/quotations`, ...(params ? [params] : [])
    ] as const;
    }

export const getListQuotationsQueryKey = (params?: ListQuotationsParams,) => {
    return [
    `/api/v3/quotations`, ...(params ? [params] : [])
    ] as const;
    }


export const useListQuotationsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof listQuotations>>>, TError = ErrorType<unknown>>(params?: ListQuotationsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listQuotations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListQuotationsInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listQuotations>>> = ({ signal }) => listQuotations(params, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, ...queryOptions});

   return  customOptions as UseInfiniteQueryOptions<Awaited<ReturnType<typeof listQuotations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListQuotationsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof listQuotations>>>
export type ListQuotationsInfiniteQueryError = ErrorType<unknown>


export function useListQuotationsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listQuotations>>>, TError = ErrorType<unknown>>(
 params: undefined |  ListQuotationsParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listQuotations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listQuotations>>,
          TError,
          Awaited<ReturnType<typeof listQuotations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListQuotationsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listQuotations>>>, TError = ErrorType<unknown>>(
 params?: ListQuotationsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listQuotations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listQuotations>>,
          TError,
          Awaited<ReturnType<typeof listQuotations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListQuotationsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listQuotations>>>, TError = ErrorType<unknown>>(
 params?: ListQuotationsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listQuotations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List of quotations
 */

export function useListQuotationsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listQuotations>>>, TError = ErrorType<unknown>>(
 params?: ListQuotationsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listQuotations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListQuotationsInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List of quotations
 */
export const prefetchListQuotationsInfiniteQuery = async <TData = Awaited<ReturnType<typeof listQuotations>>, TError = ErrorType<unknown>>(
 queryClient: QueryClient, params?: ListQuotationsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listQuotations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = useListQuotationsInfiniteQueryOptions(params,options)

  await queryClient.infiniteQuery(queryOptions).catch(() => {});

  return queryClient;
}

/**
 * @summary Invalidates the {@link useListQuotationsInfinite} query
 */
export const invalidateListQuotationsInfinite = async (
 queryClient: QueryClient, params?: ListQuotationsParams, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: customQueryOptions({ queryKey: getListQuotationsInfiniteQueryKey(params) }).queryKey }, options);

  return queryClient;
}




export const useListQuotationsQueryOptions = <TData = Awaited<ReturnType<typeof listQuotations>>, TError = ErrorType<unknown>>(params?: ListQuotationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listQuotations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListQuotationsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listQuotations>>> = ({ signal }) => listQuotations(params, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, ...queryOptions});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof listQuotations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListQuotationsQueryResult = NonNullable<Awaited<ReturnType<typeof listQuotations>>>
export type ListQuotationsQueryError = ErrorType<unknown>


export function useListQuotations<TData = Awaited<ReturnType<typeof listQuotations>>, TError = ErrorType<unknown>>(
 params: undefined |  ListQuotationsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listQuotations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listQuotations>>,
          TError,
          Awaited<ReturnType<typeof listQuotations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListQuotations<TData = Awaited<ReturnType<typeof listQuotations>>, TError = ErrorType<unknown>>(
 params?: ListQuotationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listQuotations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listQuotations>>,
          TError,
          Awaited<ReturnType<typeof listQuotations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListQuotations<TData = Awaited<ReturnType<typeof listQuotations>>, TError = ErrorType<unknown>>(
 params?: ListQuotationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listQuotations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List of quotations
 */

export function useListQuotations<TData = Awaited<ReturnType<typeof listQuotations>>, TError = ErrorType<unknown>>(
 params?: ListQuotationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listQuotations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListQuotationsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List of quotations
 */
export const prefetchListQuotationsQuery = async <TData = Awaited<ReturnType<typeof listQuotations>>, TError = ErrorType<unknown>>(
 queryClient: QueryClient, params?: ListQuotationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listQuotations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = useListQuotationsQueryOptions(params,options)

  await queryClient.query(queryOptions).catch(() => {});

  return queryClient;
}

/**
 * @summary Invalidates the {@link useListQuotations} query
 */
export const invalidateListQuotations = async (
 queryClient: QueryClient, params?: ListQuotationsParams, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: customQueryOptions({ queryKey: getListQuotationsQueryKey(params) }).queryKey }, options);

  return queryClient;
}




export const useListQuotationsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listQuotations>>, TError = ErrorType<unknown>>(params?: ListQuotationsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listQuotations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListQuotationsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listQuotations>>> = ({ signal }) => listQuotations(params, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, ...queryOptions});

   return  customOptions as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listQuotations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListQuotationsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listQuotations>>>
export type ListQuotationsSuspenseQueryError = ErrorType<unknown>


export function useListQuotationsSuspense<TData = Awaited<ReturnType<typeof listQuotations>>, TError = ErrorType<unknown>>(
 params: undefined |  ListQuotationsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listQuotations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListQuotationsSuspense<TData = Awaited<ReturnType<typeof listQuotations>>, TError = ErrorType<unknown>>(
 params?: ListQuotationsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listQuotations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListQuotationsSuspense<TData = Awaited<ReturnType<typeof listQuotations>>, TError = ErrorType<unknown>>(
 params?: ListQuotationsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listQuotations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List of quotations
 */

export function useListQuotationsSuspense<TData = Awaited<ReturnType<typeof listQuotations>>, TError = ErrorType<unknown>>(
 params?: ListQuotationsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listQuotations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListQuotationsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useListQuotationsSuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof listQuotations>>>, TError = ErrorType<unknown>>(params?: ListQuotationsParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof listQuotations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListQuotationsInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listQuotations>>> = ({ signal }) => listQuotations(params, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, ...queryOptions});

   return  customOptions as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof listQuotations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListQuotationsSuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof listQuotations>>>
export type ListQuotationsSuspenseInfiniteQueryError = ErrorType<unknown>


export function useListQuotationsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listQuotations>>>, TError = ErrorType<unknown>>(
 params: undefined |  ListQuotationsParams, options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof listQuotations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListQuotationsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listQuotations>>>, TError = ErrorType<unknown>>(
 params?: ListQuotationsParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof listQuotations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListQuotationsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listQuotations>>>, TError = ErrorType<unknown>>(
 params?: ListQuotationsParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof listQuotations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List of quotations
 */

export function useListQuotationsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listQuotations>>>, TError = ErrorType<unknown>>(
 params?: ListQuotationsParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof listQuotations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListQuotationsSuspenseInfiniteQueryOptions(params,options)

  const query = useSuspenseInfiniteQuery(queryOptions, queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Get quotations for issue purchase order
 */
export const getQuotationsForIssuePurchaseOrder = (
    params?: GetQuotationsForIssuePurchaseOrderParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<EntitiesQuotationCollectionListResponse>(
      {url: `/api/v3/quotations/issue_purchase_order`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetQuotationsForIssuePurchaseOrderInfiniteQueryKey = (params?: GetQuotationsForIssuePurchaseOrderParams,) => {
    return [
    'infinite', `/api/v3/quotations/issue_purchase_order`, ...(params ? [params] : [])
    ] as const;
    }

export const getGetQuotationsForIssuePurchaseOrderQueryKey = (params?: GetQuotationsForIssuePurchaseOrderParams,) => {
    return [
    `/api/v3/quotations/issue_purchase_order`, ...(params ? [params] : [])
    ] as const;
    }


export const useGetQuotationsForIssuePurchaseOrderInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getQuotationsForIssuePurchaseOrder>>>, TError = ErrorType<unknown>>(params?: GetQuotationsForIssuePurchaseOrderParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getQuotationsForIssuePurchaseOrder>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetQuotationsForIssuePurchaseOrderInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getQuotationsForIssuePurchaseOrder>>> = ({ signal }) => getQuotationsForIssuePurchaseOrder(params, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, ...queryOptions});

   return  customOptions as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getQuotationsForIssuePurchaseOrder>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetQuotationsForIssuePurchaseOrderInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getQuotationsForIssuePurchaseOrder>>>
export type GetQuotationsForIssuePurchaseOrderInfiniteQueryError = ErrorType<unknown>


export function useGetQuotationsForIssuePurchaseOrderInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getQuotationsForIssuePurchaseOrder>>>, TError = ErrorType<unknown>>(
 params: undefined |  GetQuotationsForIssuePurchaseOrderParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getQuotationsForIssuePurchaseOrder>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuotationsForIssuePurchaseOrder>>,
          TError,
          Awaited<ReturnType<typeof getQuotationsForIssuePurchaseOrder>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetQuotationsForIssuePurchaseOrderInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getQuotationsForIssuePurchaseOrder>>>, TError = ErrorType<unknown>>(
 params?: GetQuotationsForIssuePurchaseOrderParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getQuotationsForIssuePurchaseOrder>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuotationsForIssuePurchaseOrder>>,
          TError,
          Awaited<ReturnType<typeof getQuotationsForIssuePurchaseOrder>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetQuotationsForIssuePurchaseOrderInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getQuotationsForIssuePurchaseOrder>>>, TError = ErrorType<unknown>>(
 params?: GetQuotationsForIssuePurchaseOrderParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getQuotationsForIssuePurchaseOrder>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get quotations for issue purchase order
 */

export function useGetQuotationsForIssuePurchaseOrderInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getQuotationsForIssuePurchaseOrder>>>, TError = ErrorType<unknown>>(
 params?: GetQuotationsForIssuePurchaseOrderParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getQuotationsForIssuePurchaseOrder>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetQuotationsForIssuePurchaseOrderInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get quotations for issue purchase order
 */
export const prefetchGetQuotationsForIssuePurchaseOrderInfiniteQuery = async <TData = Awaited<ReturnType<typeof getQuotationsForIssuePurchaseOrder>>, TError = ErrorType<unknown>>(
 queryClient: QueryClient, params?: GetQuotationsForIssuePurchaseOrderParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getQuotationsForIssuePurchaseOrder>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = useGetQuotationsForIssuePurchaseOrderInfiniteQueryOptions(params,options)

  await queryClient.infiniteQuery(queryOptions).catch(() => {});

  return queryClient;
}

/**
 * @summary Invalidates the {@link useGetQuotationsForIssuePurchaseOrderInfinite} query
 */
export const invalidateGetQuotationsForIssuePurchaseOrderInfinite = async (
 queryClient: QueryClient, params?: GetQuotationsForIssuePurchaseOrderParams, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: customQueryOptions({ queryKey: getGetQuotationsForIssuePurchaseOrderInfiniteQueryKey(params) }).queryKey }, options);

  return queryClient;
}




export const useGetQuotationsForIssuePurchaseOrderQueryOptions = <TData = Awaited<ReturnType<typeof getQuotationsForIssuePurchaseOrder>>, TError = ErrorType<unknown>>(params?: GetQuotationsForIssuePurchaseOrderParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotationsForIssuePurchaseOrder>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetQuotationsForIssuePurchaseOrderQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getQuotationsForIssuePurchaseOrder>>> = ({ signal }) => getQuotationsForIssuePurchaseOrder(params, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, ...queryOptions});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof getQuotationsForIssuePurchaseOrder>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetQuotationsForIssuePurchaseOrderQueryResult = NonNullable<Awaited<ReturnType<typeof getQuotationsForIssuePurchaseOrder>>>
export type GetQuotationsForIssuePurchaseOrderQueryError = ErrorType<unknown>


export function useGetQuotationsForIssuePurchaseOrder<TData = Awaited<ReturnType<typeof getQuotationsForIssuePurchaseOrder>>, TError = ErrorType<unknown>>(
 params: undefined |  GetQuotationsForIssuePurchaseOrderParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotationsForIssuePurchaseOrder>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuotationsForIssuePurchaseOrder>>,
          TError,
          Awaited<ReturnType<typeof getQuotationsForIssuePurchaseOrder>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetQuotationsForIssuePurchaseOrder<TData = Awaited<ReturnType<typeof getQuotationsForIssuePurchaseOrder>>, TError = ErrorType<unknown>>(
 params?: GetQuotationsForIssuePurchaseOrderParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotationsForIssuePurchaseOrder>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuotationsForIssuePurchaseOrder>>,
          TError,
          Awaited<ReturnType<typeof getQuotationsForIssuePurchaseOrder>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetQuotationsForIssuePurchaseOrder<TData = Awaited<ReturnType<typeof getQuotationsForIssuePurchaseOrder>>, TError = ErrorType<unknown>>(
 params?: GetQuotationsForIssuePurchaseOrderParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotationsForIssuePurchaseOrder>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get quotations for issue purchase order
 */

export function useGetQuotationsForIssuePurchaseOrder<TData = Awaited<ReturnType<typeof getQuotationsForIssuePurchaseOrder>>, TError = ErrorType<unknown>>(
 params?: GetQuotationsForIssuePurchaseOrderParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotationsForIssuePurchaseOrder>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetQuotationsForIssuePurchaseOrderQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get quotations for issue purchase order
 */
export const prefetchGetQuotationsForIssuePurchaseOrderQuery = async <TData = Awaited<ReturnType<typeof getQuotationsForIssuePurchaseOrder>>, TError = ErrorType<unknown>>(
 queryClient: QueryClient, params?: GetQuotationsForIssuePurchaseOrderParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotationsForIssuePurchaseOrder>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = useGetQuotationsForIssuePurchaseOrderQueryOptions(params,options)

  await queryClient.query(queryOptions).catch(() => {});

  return queryClient;
}

/**
 * @summary Invalidates the {@link useGetQuotationsForIssuePurchaseOrder} query
 */
export const invalidateGetQuotationsForIssuePurchaseOrder = async (
 queryClient: QueryClient, params?: GetQuotationsForIssuePurchaseOrderParams, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: customQueryOptions({ queryKey: getGetQuotationsForIssuePurchaseOrderQueryKey(params) }).queryKey }, options);

  return queryClient;
}




export const useGetQuotationsForIssuePurchaseOrderSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getQuotationsForIssuePurchaseOrder>>, TError = ErrorType<unknown>>(params?: GetQuotationsForIssuePurchaseOrderParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getQuotationsForIssuePurchaseOrder>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetQuotationsForIssuePurchaseOrderQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getQuotationsForIssuePurchaseOrder>>> = ({ signal }) => getQuotationsForIssuePurchaseOrder(params, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, ...queryOptions});

   return  customOptions as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getQuotationsForIssuePurchaseOrder>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetQuotationsForIssuePurchaseOrderSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getQuotationsForIssuePurchaseOrder>>>
export type GetQuotationsForIssuePurchaseOrderSuspenseQueryError = ErrorType<unknown>


export function useGetQuotationsForIssuePurchaseOrderSuspense<TData = Awaited<ReturnType<typeof getQuotationsForIssuePurchaseOrder>>, TError = ErrorType<unknown>>(
 params: undefined |  GetQuotationsForIssuePurchaseOrderParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getQuotationsForIssuePurchaseOrder>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetQuotationsForIssuePurchaseOrderSuspense<TData = Awaited<ReturnType<typeof getQuotationsForIssuePurchaseOrder>>, TError = ErrorType<unknown>>(
 params?: GetQuotationsForIssuePurchaseOrderParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getQuotationsForIssuePurchaseOrder>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetQuotationsForIssuePurchaseOrderSuspense<TData = Awaited<ReturnType<typeof getQuotationsForIssuePurchaseOrder>>, TError = ErrorType<unknown>>(
 params?: GetQuotationsForIssuePurchaseOrderParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getQuotationsForIssuePurchaseOrder>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get quotations for issue purchase order
 */

export function useGetQuotationsForIssuePurchaseOrderSuspense<TData = Awaited<ReturnType<typeof getQuotationsForIssuePurchaseOrder>>, TError = ErrorType<unknown>>(
 params?: GetQuotationsForIssuePurchaseOrderParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getQuotationsForIssuePurchaseOrder>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetQuotationsForIssuePurchaseOrderSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useGetQuotationsForIssuePurchaseOrderSuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getQuotationsForIssuePurchaseOrder>>>, TError = ErrorType<unknown>>(params?: GetQuotationsForIssuePurchaseOrderParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getQuotationsForIssuePurchaseOrder>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetQuotationsForIssuePurchaseOrderInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getQuotationsForIssuePurchaseOrder>>> = ({ signal }) => getQuotationsForIssuePurchaseOrder(params, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, ...queryOptions});

   return  customOptions as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getQuotationsForIssuePurchaseOrder>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetQuotationsForIssuePurchaseOrderSuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getQuotationsForIssuePurchaseOrder>>>
export type GetQuotationsForIssuePurchaseOrderSuspenseInfiniteQueryError = ErrorType<unknown>


export function useGetQuotationsForIssuePurchaseOrderSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getQuotationsForIssuePurchaseOrder>>>, TError = ErrorType<unknown>>(
 params: undefined |  GetQuotationsForIssuePurchaseOrderParams, options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getQuotationsForIssuePurchaseOrder>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetQuotationsForIssuePurchaseOrderSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getQuotationsForIssuePurchaseOrder>>>, TError = ErrorType<unknown>>(
 params?: GetQuotationsForIssuePurchaseOrderParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getQuotationsForIssuePurchaseOrder>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetQuotationsForIssuePurchaseOrderSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getQuotationsForIssuePurchaseOrder>>>, TError = ErrorType<unknown>>(
 params?: GetQuotationsForIssuePurchaseOrderParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getQuotationsForIssuePurchaseOrder>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get quotations for issue purchase order
 */

export function useGetQuotationsForIssuePurchaseOrderSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getQuotationsForIssuePurchaseOrder>>>, TError = ErrorType<unknown>>(
 params?: GetQuotationsForIssuePurchaseOrderParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getQuotationsForIssuePurchaseOrder>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetQuotationsForIssuePurchaseOrderSuspenseInfiniteQueryOptions(params,options)

  const query = useSuspenseInfiniteQuery(queryOptions, queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Get approval statistics
 */
export const getApprovalStatistics = (
    params: GetApprovalStatisticsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<EntitiesQuotationCollectionApprovalStats>(
      {url: `/api/v3/quotations/approval_stats`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetApprovalStatisticsInfiniteQueryKey = (params?: GetApprovalStatisticsParams,) => {
    return [
    'infinite', `/api/v3/quotations/approval_stats`, ...(params ? [params] : [])
    ] as const;
    }

export const getGetApprovalStatisticsQueryKey = (params?: GetApprovalStatisticsParams,) => {
    return [
    `/api/v3/quotations/approval_stats`, ...(params ? [params] : [])
    ] as const;
    }


export const useGetApprovalStatisticsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getApprovalStatistics>>>, TError = ErrorType<unknown>>(params: GetApprovalStatisticsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApprovalStatistics>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApprovalStatisticsInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApprovalStatistics>>> = ({ signal }) => getApprovalStatistics(params, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, ...queryOptions});

   return  customOptions as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApprovalStatistics>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApprovalStatisticsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getApprovalStatistics>>>
export type GetApprovalStatisticsInfiniteQueryError = ErrorType<unknown>


export function useGetApprovalStatisticsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApprovalStatistics>>>, TError = ErrorType<unknown>>(
 params: GetApprovalStatisticsParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApprovalStatistics>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApprovalStatistics>>,
          TError,
          Awaited<ReturnType<typeof getApprovalStatistics>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApprovalStatisticsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApprovalStatistics>>>, TError = ErrorType<unknown>>(
 params: GetApprovalStatisticsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApprovalStatistics>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApprovalStatistics>>,
          TError,
          Awaited<ReturnType<typeof getApprovalStatistics>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApprovalStatisticsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApprovalStatistics>>>, TError = ErrorType<unknown>>(
 params: GetApprovalStatisticsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApprovalStatistics>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get approval statistics
 */

export function useGetApprovalStatisticsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApprovalStatistics>>>, TError = ErrorType<unknown>>(
 params: GetApprovalStatisticsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApprovalStatistics>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetApprovalStatisticsInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get approval statistics
 */
export const prefetchGetApprovalStatisticsInfiniteQuery = async <TData = Awaited<ReturnType<typeof getApprovalStatistics>>, TError = ErrorType<unknown>>(
 queryClient: QueryClient, params: GetApprovalStatisticsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApprovalStatistics>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = useGetApprovalStatisticsInfiniteQueryOptions(params,options)

  await queryClient.infiniteQuery(queryOptions).catch(() => {});

  return queryClient;
}

/**
 * @summary Invalidates the {@link useGetApprovalStatisticsInfinite} query
 */
export const invalidateGetApprovalStatisticsInfinite = async (
 queryClient: QueryClient, params: GetApprovalStatisticsParams, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: customQueryOptions({ queryKey: getGetApprovalStatisticsInfiniteQueryKey(params) }).queryKey }, options);

  return queryClient;
}




export const useGetApprovalStatisticsQueryOptions = <TData = Awaited<ReturnType<typeof getApprovalStatistics>>, TError = ErrorType<unknown>>(params: GetApprovalStatisticsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApprovalStatistics>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApprovalStatisticsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApprovalStatistics>>> = ({ signal }) => getApprovalStatistics(params, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, ...queryOptions});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof getApprovalStatistics>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApprovalStatisticsQueryResult = NonNullable<Awaited<ReturnType<typeof getApprovalStatistics>>>
export type GetApprovalStatisticsQueryError = ErrorType<unknown>


export function useGetApprovalStatistics<TData = Awaited<ReturnType<typeof getApprovalStatistics>>, TError = ErrorType<unknown>>(
 params: GetApprovalStatisticsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApprovalStatistics>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApprovalStatistics>>,
          TError,
          Awaited<ReturnType<typeof getApprovalStatistics>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApprovalStatistics<TData = Awaited<ReturnType<typeof getApprovalStatistics>>, TError = ErrorType<unknown>>(
 params: GetApprovalStatisticsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApprovalStatistics>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApprovalStatistics>>,
          TError,
          Awaited<ReturnType<typeof getApprovalStatistics>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApprovalStatistics<TData = Awaited<ReturnType<typeof getApprovalStatistics>>, TError = ErrorType<unknown>>(
 params: GetApprovalStatisticsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApprovalStatistics>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get approval statistics
 */

export function useGetApprovalStatistics<TData = Awaited<ReturnType<typeof getApprovalStatistics>>, TError = ErrorType<unknown>>(
 params: GetApprovalStatisticsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApprovalStatistics>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetApprovalStatisticsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get approval statistics
 */
export const prefetchGetApprovalStatisticsQuery = async <TData = Awaited<ReturnType<typeof getApprovalStatistics>>, TError = ErrorType<unknown>>(
 queryClient: QueryClient, params: GetApprovalStatisticsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApprovalStatistics>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = useGetApprovalStatisticsQueryOptions(params,options)

  await queryClient.query(queryOptions).catch(() => {});

  return queryClient;
}

/**
 * @summary Invalidates the {@link useGetApprovalStatistics} query
 */
export const invalidateGetApprovalStatistics = async (
 queryClient: QueryClient, params: GetApprovalStatisticsParams, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: customQueryOptions({ queryKey: getGetApprovalStatisticsQueryKey(params) }).queryKey }, options);

  return queryClient;
}




export const useGetApprovalStatisticsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getApprovalStatistics>>, TError = ErrorType<unknown>>(params: GetApprovalStatisticsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApprovalStatistics>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApprovalStatisticsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApprovalStatistics>>> = ({ signal }) => getApprovalStatistics(params, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, ...queryOptions});

   return  customOptions as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApprovalStatistics>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApprovalStatisticsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getApprovalStatistics>>>
export type GetApprovalStatisticsSuspenseQueryError = ErrorType<unknown>


export function useGetApprovalStatisticsSuspense<TData = Awaited<ReturnType<typeof getApprovalStatistics>>, TError = ErrorType<unknown>>(
 params: GetApprovalStatisticsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApprovalStatistics>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApprovalStatisticsSuspense<TData = Awaited<ReturnType<typeof getApprovalStatistics>>, TError = ErrorType<unknown>>(
 params: GetApprovalStatisticsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApprovalStatistics>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApprovalStatisticsSuspense<TData = Awaited<ReturnType<typeof getApprovalStatistics>>, TError = ErrorType<unknown>>(
 params: GetApprovalStatisticsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApprovalStatistics>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get approval statistics
 */

export function useGetApprovalStatisticsSuspense<TData = Awaited<ReturnType<typeof getApprovalStatistics>>, TError = ErrorType<unknown>>(
 params: GetApprovalStatisticsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApprovalStatistics>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetApprovalStatisticsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useGetApprovalStatisticsSuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getApprovalStatistics>>>, TError = ErrorType<unknown>>(params: GetApprovalStatisticsParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getApprovalStatistics>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApprovalStatisticsInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApprovalStatistics>>> = ({ signal }) => getApprovalStatistics(params, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, ...queryOptions});

   return  customOptions as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getApprovalStatistics>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApprovalStatisticsSuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getApprovalStatistics>>>
export type GetApprovalStatisticsSuspenseInfiniteQueryError = ErrorType<unknown>


export function useGetApprovalStatisticsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApprovalStatistics>>>, TError = ErrorType<unknown>>(
 params: GetApprovalStatisticsParams, options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getApprovalStatistics>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApprovalStatisticsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApprovalStatistics>>>, TError = ErrorType<unknown>>(
 params: GetApprovalStatisticsParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getApprovalStatistics>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApprovalStatisticsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApprovalStatistics>>>, TError = ErrorType<unknown>>(
 params: GetApprovalStatisticsParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getApprovalStatistics>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get approval statistics
 */

export function useGetApprovalStatisticsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApprovalStatistics>>>, TError = ErrorType<unknown>>(
 params: GetApprovalStatisticsParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getApprovalStatistics>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetApprovalStatisticsSuspenseInfiniteQueryOptions(params,options)

  const query = useSuspenseInfiniteQuery(queryOptions, queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Preview purchase order groups that will be generated for the selected quotations
 */
export const purchaseOrderPreview = (
    params: PurchaseOrderPreviewParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<EntitiesQuotationCollectionPurchaseOrderPreviewItem[]>(
      {url: `/api/v3/quotations/purchase_order_preview`, method: 'GET',
        params, signal
    },
      options);
    }




export const getPurchaseOrderPreviewInfiniteQueryKey = (params?: PurchaseOrderPreviewParams,) => {
    return [
    'infinite', `/api/v3/quotations/purchase_order_preview`, ...(params ? [params] : [])
    ] as const;
    }

export const getPurchaseOrderPreviewQueryKey = (params?: PurchaseOrderPreviewParams,) => {
    return [
    `/api/v3/quotations/purchase_order_preview`, ...(params ? [params] : [])
    ] as const;
    }


export const usePurchaseOrderPreviewInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof purchaseOrderPreview>>>, TError = ErrorType<unknown>>(params: PurchaseOrderPreviewParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof purchaseOrderPreview>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPurchaseOrderPreviewInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof purchaseOrderPreview>>> = ({ signal }) => purchaseOrderPreview(params, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, ...queryOptions});

   return  customOptions as UseInfiniteQueryOptions<Awaited<ReturnType<typeof purchaseOrderPreview>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PurchaseOrderPreviewInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof purchaseOrderPreview>>>
export type PurchaseOrderPreviewInfiniteQueryError = ErrorType<unknown>


export function usePurchaseOrderPreviewInfinite<TData = InfiniteData<Awaited<ReturnType<typeof purchaseOrderPreview>>>, TError = ErrorType<unknown>>(
 params: PurchaseOrderPreviewParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof purchaseOrderPreview>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof purchaseOrderPreview>>,
          TError,
          Awaited<ReturnType<typeof purchaseOrderPreview>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePurchaseOrderPreviewInfinite<TData = InfiniteData<Awaited<ReturnType<typeof purchaseOrderPreview>>>, TError = ErrorType<unknown>>(
 params: PurchaseOrderPreviewParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof purchaseOrderPreview>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof purchaseOrderPreview>>,
          TError,
          Awaited<ReturnType<typeof purchaseOrderPreview>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePurchaseOrderPreviewInfinite<TData = InfiniteData<Awaited<ReturnType<typeof purchaseOrderPreview>>>, TError = ErrorType<unknown>>(
 params: PurchaseOrderPreviewParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof purchaseOrderPreview>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Preview purchase order groups that will be generated for the selected quotations
 */

export function usePurchaseOrderPreviewInfinite<TData = InfiniteData<Awaited<ReturnType<typeof purchaseOrderPreview>>>, TError = ErrorType<unknown>>(
 params: PurchaseOrderPreviewParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof purchaseOrderPreview>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = usePurchaseOrderPreviewInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Preview purchase order groups that will be generated for the selected quotations
 */
export const prefetchPurchaseOrderPreviewInfiniteQuery = async <TData = Awaited<ReturnType<typeof purchaseOrderPreview>>, TError = ErrorType<unknown>>(
 queryClient: QueryClient, params: PurchaseOrderPreviewParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof purchaseOrderPreview>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = usePurchaseOrderPreviewInfiniteQueryOptions(params,options)

  await queryClient.infiniteQuery(queryOptions).catch(() => {});

  return queryClient;
}

/**
 * @summary Invalidates the {@link usePurchaseOrderPreviewInfinite} query
 */
export const invalidatePurchaseOrderPreviewInfinite = async (
 queryClient: QueryClient, params: PurchaseOrderPreviewParams, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: customQueryOptions({ queryKey: getPurchaseOrderPreviewInfiniteQueryKey(params) }).queryKey }, options);

  return queryClient;
}




export const usePurchaseOrderPreviewQueryOptions = <TData = Awaited<ReturnType<typeof purchaseOrderPreview>>, TError = ErrorType<unknown>>(params: PurchaseOrderPreviewParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof purchaseOrderPreview>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPurchaseOrderPreviewQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof purchaseOrderPreview>>> = ({ signal }) => purchaseOrderPreview(params, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, ...queryOptions});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof purchaseOrderPreview>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PurchaseOrderPreviewQueryResult = NonNullable<Awaited<ReturnType<typeof purchaseOrderPreview>>>
export type PurchaseOrderPreviewQueryError = ErrorType<unknown>


export function usePurchaseOrderPreview<TData = Awaited<ReturnType<typeof purchaseOrderPreview>>, TError = ErrorType<unknown>>(
 params: PurchaseOrderPreviewParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof purchaseOrderPreview>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof purchaseOrderPreview>>,
          TError,
          Awaited<ReturnType<typeof purchaseOrderPreview>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePurchaseOrderPreview<TData = Awaited<ReturnType<typeof purchaseOrderPreview>>, TError = ErrorType<unknown>>(
 params: PurchaseOrderPreviewParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof purchaseOrderPreview>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof purchaseOrderPreview>>,
          TError,
          Awaited<ReturnType<typeof purchaseOrderPreview>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePurchaseOrderPreview<TData = Awaited<ReturnType<typeof purchaseOrderPreview>>, TError = ErrorType<unknown>>(
 params: PurchaseOrderPreviewParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof purchaseOrderPreview>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Preview purchase order groups that will be generated for the selected quotations
 */

export function usePurchaseOrderPreview<TData = Awaited<ReturnType<typeof purchaseOrderPreview>>, TError = ErrorType<unknown>>(
 params: PurchaseOrderPreviewParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof purchaseOrderPreview>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = usePurchaseOrderPreviewQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Preview purchase order groups that will be generated for the selected quotations
 */
export const prefetchPurchaseOrderPreviewQuery = async <TData = Awaited<ReturnType<typeof purchaseOrderPreview>>, TError = ErrorType<unknown>>(
 queryClient: QueryClient, params: PurchaseOrderPreviewParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof purchaseOrderPreview>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = usePurchaseOrderPreviewQueryOptions(params,options)

  await queryClient.query(queryOptions).catch(() => {});

  return queryClient;
}

/**
 * @summary Invalidates the {@link usePurchaseOrderPreview} query
 */
export const invalidatePurchaseOrderPreview = async (
 queryClient: QueryClient, params: PurchaseOrderPreviewParams, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: customQueryOptions({ queryKey: getPurchaseOrderPreviewQueryKey(params) }).queryKey }, options);

  return queryClient;
}




export const usePurchaseOrderPreviewSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof purchaseOrderPreview>>, TError = ErrorType<unknown>>(params: PurchaseOrderPreviewParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof purchaseOrderPreview>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPurchaseOrderPreviewQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof purchaseOrderPreview>>> = ({ signal }) => purchaseOrderPreview(params, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, ...queryOptions});

   return  customOptions as UseSuspenseQueryOptions<Awaited<ReturnType<typeof purchaseOrderPreview>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PurchaseOrderPreviewSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof purchaseOrderPreview>>>
export type PurchaseOrderPreviewSuspenseQueryError = ErrorType<unknown>


export function usePurchaseOrderPreviewSuspense<TData = Awaited<ReturnType<typeof purchaseOrderPreview>>, TError = ErrorType<unknown>>(
 params: PurchaseOrderPreviewParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof purchaseOrderPreview>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePurchaseOrderPreviewSuspense<TData = Awaited<ReturnType<typeof purchaseOrderPreview>>, TError = ErrorType<unknown>>(
 params: PurchaseOrderPreviewParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof purchaseOrderPreview>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePurchaseOrderPreviewSuspense<TData = Awaited<ReturnType<typeof purchaseOrderPreview>>, TError = ErrorType<unknown>>(
 params: PurchaseOrderPreviewParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof purchaseOrderPreview>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Preview purchase order groups that will be generated for the selected quotations
 */

export function usePurchaseOrderPreviewSuspense<TData = Awaited<ReturnType<typeof purchaseOrderPreview>>, TError = ErrorType<unknown>>(
 params: PurchaseOrderPreviewParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof purchaseOrderPreview>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = usePurchaseOrderPreviewSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const usePurchaseOrderPreviewSuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof purchaseOrderPreview>>>, TError = ErrorType<unknown>>(params: PurchaseOrderPreviewParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof purchaseOrderPreview>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPurchaseOrderPreviewInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof purchaseOrderPreview>>> = ({ signal }) => purchaseOrderPreview(params, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, ...queryOptions});

   return  customOptions as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof purchaseOrderPreview>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PurchaseOrderPreviewSuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof purchaseOrderPreview>>>
export type PurchaseOrderPreviewSuspenseInfiniteQueryError = ErrorType<unknown>


export function usePurchaseOrderPreviewSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof purchaseOrderPreview>>>, TError = ErrorType<unknown>>(
 params: PurchaseOrderPreviewParams, options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof purchaseOrderPreview>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePurchaseOrderPreviewSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof purchaseOrderPreview>>>, TError = ErrorType<unknown>>(
 params: PurchaseOrderPreviewParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof purchaseOrderPreview>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePurchaseOrderPreviewSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof purchaseOrderPreview>>>, TError = ErrorType<unknown>>(
 params: PurchaseOrderPreviewParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof purchaseOrderPreview>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Preview purchase order groups that will be generated for the selected quotations
 */

export function usePurchaseOrderPreviewSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof purchaseOrderPreview>>>, TError = ErrorType<unknown>>(
 params: PurchaseOrderPreviewParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof purchaseOrderPreview>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = usePurchaseOrderPreviewSuspenseInfiniteQueryOptions(params,options)

  const query = useSuspenseInfiniteQuery(queryOptions, queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Create validation quotations (development only)
 */
export const createValidationQuotations = (
    createValidationQuotationsRequest: CreateValidationQuotationsRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<EntitiesQuotationCollectionValidationResult>(
      {url: `/api/v3/quotations/create_validation_quotations`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createValidationQuotationsRequest, signal
    },
      options);
    }




export const getCreateValidationQuotationsMutationKey = () => ['createValidationQuotations'] as const;

export const getCreateValidationQuotationsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createValidationQuotations>>, TError,CreateValidationQuotationsMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createValidationQuotations>>, TError,CreateValidationQuotationsMutationVariables, TContext> => {

const mutationKey = getCreateValidationQuotationsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createValidationQuotations>>, CreateValidationQuotationsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createValidationQuotations(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateValidationQuotationsMutationResult = NonNullable<Awaited<ReturnType<typeof createValidationQuotations>>>
    export type CreateValidationQuotationsMutationBody = CreateValidationQuotationsRequest
    export type CreateValidationQuotationsMutationError = ErrorType<unknown>
    export type CreateValidationQuotationsMutationVariables = {data: CreateValidationQuotationsRequest}

    /**
 * @summary Create validation quotations (development only)
 */
export const useCreateValidationQuotations = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createValidationQuotations>>, TError,CreateValidationQuotationsMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createValidationQuotations>>,
        TError,
        CreateValidationQuotationsMutationVariables,
        TContext
      > => {
      return useMutation(getCreateValidationQuotationsMutationOptions(options), queryClient);
    }
    /**
 * @summary Mass reopen offer windows for pending buyer quotations
 */
export const massReopenOfferWindow = (
    massReopenOfferWindowRequest: MassReopenOfferWindowRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<EntitiesQuotationCollectionMassReopenResponse>(
      {url: `/api/v3/quotations/mass_reopen_offer_window`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: massReopenOfferWindowRequest, signal
    },
      options);
    }




export const getMassReopenOfferWindowMutationKey = () => ['massReopenOfferWindow'] as const;

export const getMassReopenOfferWindowMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof massReopenOfferWindow>>, TError,MassReopenOfferWindowMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof massReopenOfferWindow>>, TError,MassReopenOfferWindowMutationVariables, TContext> => {

const mutationKey = getMassReopenOfferWindowMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof massReopenOfferWindow>>, MassReopenOfferWindowMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  massReopenOfferWindow(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MassReopenOfferWindowMutationResult = NonNullable<Awaited<ReturnType<typeof massReopenOfferWindow>>>
    export type MassReopenOfferWindowMutationBody = MassReopenOfferWindowRequest
    export type MassReopenOfferWindowMutationError = ErrorType<unknown>
    export type MassReopenOfferWindowMutationVariables = {data: MassReopenOfferWindowRequest}

    /**
 * @summary Mass reopen offer windows for pending buyer quotations
 */
export const useMassReopenOfferWindow = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof massReopenOfferWindow>>, TError,MassReopenOfferWindowMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof massReopenOfferWindow>>,
        TError,
        MassReopenOfferWindowMutationVariables,
        TContext
      > => {
      return useMutation(getMassReopenOfferWindowMutationOptions(options), queryClient);
    }
    /**
 * @summary Show quotation
 */
export const showQuotation = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<EntitiesQuotationMemberMain>(
      {url: `/api/v3/quotations/${id}`, method: 'GET', signal
    },
      options);
    }




export const getShowQuotationInfiniteQueryKey = (id: number,) => {
    return [
    'infinite', `/api/v3/quotations/${id}`
    ] as const;
    }

export const getShowQuotationQueryKey = (id: number,) => {
    return [
    `/api/v3/quotations/${id}`
    ] as const;
    }


export const useShowQuotationInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof showQuotation>>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof showQuotation>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getShowQuotationInfiniteQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof showQuotation>>> = ({ signal }) => showQuotation(id, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions});

   return  customOptions as UseInfiniteQueryOptions<Awaited<ReturnType<typeof showQuotation>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ShowQuotationInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof showQuotation>>>
export type ShowQuotationInfiniteQueryError = ErrorType<unknown>


export function useShowQuotationInfinite<TData = InfiniteData<Awaited<ReturnType<typeof showQuotation>>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof showQuotation>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof showQuotation>>,
          TError,
          Awaited<ReturnType<typeof showQuotation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShowQuotationInfinite<TData = InfiniteData<Awaited<ReturnType<typeof showQuotation>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof showQuotation>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof showQuotation>>,
          TError,
          Awaited<ReturnType<typeof showQuotation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShowQuotationInfinite<TData = InfiniteData<Awaited<ReturnType<typeof showQuotation>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof showQuotation>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Show quotation
 */

export function useShowQuotationInfinite<TData = InfiniteData<Awaited<ReturnType<typeof showQuotation>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof showQuotation>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useShowQuotationInfiniteQueryOptions(id,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Show quotation
 */
export const prefetchShowQuotationInfiniteQuery = async <TData = Awaited<ReturnType<typeof showQuotation>>, TError = ErrorType<unknown>>(
 queryClient: QueryClient, id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof showQuotation>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = useShowQuotationInfiniteQueryOptions(id,options)

  await queryClient.infiniteQuery(queryOptions).catch(() => {});

  return queryClient;
}

/**
 * @summary Invalidates the {@link useShowQuotationInfinite} query
 */
export const invalidateShowQuotationInfinite = async (
 queryClient: QueryClient, id: number, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: customQueryOptions({ queryKey: getShowQuotationInfiniteQueryKey(id) }).queryKey }, options);

  return queryClient;
}




export const useShowQuotationQueryOptions = <TData = Awaited<ReturnType<typeof showQuotation>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof showQuotation>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getShowQuotationQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof showQuotation>>> = ({ signal }) => showQuotation(id, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof showQuotation>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ShowQuotationQueryResult = NonNullable<Awaited<ReturnType<typeof showQuotation>>>
export type ShowQuotationQueryError = ErrorType<unknown>


export function useShowQuotation<TData = Awaited<ReturnType<typeof showQuotation>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof showQuotation>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof showQuotation>>,
          TError,
          Awaited<ReturnType<typeof showQuotation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShowQuotation<TData = Awaited<ReturnType<typeof showQuotation>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof showQuotation>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof showQuotation>>,
          TError,
          Awaited<ReturnType<typeof showQuotation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShowQuotation<TData = Awaited<ReturnType<typeof showQuotation>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof showQuotation>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Show quotation
 */

export function useShowQuotation<TData = Awaited<ReturnType<typeof showQuotation>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof showQuotation>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useShowQuotationQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Show quotation
 */
export const prefetchShowQuotationQuery = async <TData = Awaited<ReturnType<typeof showQuotation>>, TError = ErrorType<unknown>>(
 queryClient: QueryClient, id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof showQuotation>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = useShowQuotationQueryOptions(id,options)

  await queryClient.query(queryOptions).catch(() => {});

  return queryClient;
}

/**
 * @summary Invalidates the {@link useShowQuotation} query
 */
export const invalidateShowQuotation = async (
 queryClient: QueryClient, id: number, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: customQueryOptions({ queryKey: getShowQuotationQueryKey(id) }).queryKey }, options);

  return queryClient;
}




export const useShowQuotationSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof showQuotation>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof showQuotation>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getShowQuotationQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof showQuotation>>> = ({ signal }) => showQuotation(id, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, ...queryOptions});

   return  customOptions as UseSuspenseQueryOptions<Awaited<ReturnType<typeof showQuotation>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ShowQuotationSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof showQuotation>>>
export type ShowQuotationSuspenseQueryError = ErrorType<unknown>


export function useShowQuotationSuspense<TData = Awaited<ReturnType<typeof showQuotation>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof showQuotation>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShowQuotationSuspense<TData = Awaited<ReturnType<typeof showQuotation>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof showQuotation>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShowQuotationSuspense<TData = Awaited<ReturnType<typeof showQuotation>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof showQuotation>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Show quotation
 */

export function useShowQuotationSuspense<TData = Awaited<ReturnType<typeof showQuotation>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof showQuotation>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useShowQuotationSuspenseQueryOptions(id,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useShowQuotationSuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof showQuotation>>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof showQuotation>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getShowQuotationInfiniteQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof showQuotation>>> = ({ signal }) => showQuotation(id, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, ...queryOptions});

   return  customOptions as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof showQuotation>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ShowQuotationSuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof showQuotation>>>
export type ShowQuotationSuspenseInfiniteQueryError = ErrorType<unknown>


export function useShowQuotationSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof showQuotation>>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof showQuotation>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShowQuotationSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof showQuotation>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof showQuotation>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShowQuotationSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof showQuotation>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof showQuotation>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Show quotation
 */

export function useShowQuotationSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof showQuotation>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof showQuotation>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useShowQuotationSuspenseInfiniteQueryOptions(id,options)

  const query = useSuspenseInfiniteQuery(queryOptions, queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Get quotation open doubts status
 */
export const getQuotationHasOpenDoubts = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<EntitiesQuotationMemberOpenDoubts>(
      {url: `/api/v3/quotations/${id}/has_open_doubts`, method: 'GET', signal
    },
      options);
    }




export const getGetQuotationHasOpenDoubtsInfiniteQueryKey = (id: number,) => {
    return [
    'infinite', `/api/v3/quotations/${id}/has_open_doubts`
    ] as const;
    }

export const getGetQuotationHasOpenDoubtsQueryKey = (id: number,) => {
    return [
    `/api/v3/quotations/${id}/has_open_doubts`
    ] as const;
    }


export const useGetQuotationHasOpenDoubtsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getQuotationHasOpenDoubts>>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getQuotationHasOpenDoubts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetQuotationHasOpenDoubtsInfiniteQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getQuotationHasOpenDoubts>>> = ({ signal }) => getQuotationHasOpenDoubts(id, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions});

   return  customOptions as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getQuotationHasOpenDoubts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetQuotationHasOpenDoubtsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getQuotationHasOpenDoubts>>>
export type GetQuotationHasOpenDoubtsInfiniteQueryError = ErrorType<unknown>


export function useGetQuotationHasOpenDoubtsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getQuotationHasOpenDoubts>>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getQuotationHasOpenDoubts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuotationHasOpenDoubts>>,
          TError,
          Awaited<ReturnType<typeof getQuotationHasOpenDoubts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetQuotationHasOpenDoubtsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getQuotationHasOpenDoubts>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getQuotationHasOpenDoubts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuotationHasOpenDoubts>>,
          TError,
          Awaited<ReturnType<typeof getQuotationHasOpenDoubts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetQuotationHasOpenDoubtsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getQuotationHasOpenDoubts>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getQuotationHasOpenDoubts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get quotation open doubts status
 */

export function useGetQuotationHasOpenDoubtsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getQuotationHasOpenDoubts>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getQuotationHasOpenDoubts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetQuotationHasOpenDoubtsInfiniteQueryOptions(id,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get quotation open doubts status
 */
export const prefetchGetQuotationHasOpenDoubtsInfiniteQuery = async <TData = Awaited<ReturnType<typeof getQuotationHasOpenDoubts>>, TError = ErrorType<unknown>>(
 queryClient: QueryClient, id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getQuotationHasOpenDoubts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = useGetQuotationHasOpenDoubtsInfiniteQueryOptions(id,options)

  await queryClient.infiniteQuery(queryOptions).catch(() => {});

  return queryClient;
}

/**
 * @summary Invalidates the {@link useGetQuotationHasOpenDoubtsInfinite} query
 */
export const invalidateGetQuotationHasOpenDoubtsInfinite = async (
 queryClient: QueryClient, id: number, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: customQueryOptions({ queryKey: getGetQuotationHasOpenDoubtsInfiniteQueryKey(id) }).queryKey }, options);

  return queryClient;
}




export const useGetQuotationHasOpenDoubtsQueryOptions = <TData = Awaited<ReturnType<typeof getQuotationHasOpenDoubts>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotationHasOpenDoubts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetQuotationHasOpenDoubtsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getQuotationHasOpenDoubts>>> = ({ signal }) => getQuotationHasOpenDoubts(id, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof getQuotationHasOpenDoubts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetQuotationHasOpenDoubtsQueryResult = NonNullable<Awaited<ReturnType<typeof getQuotationHasOpenDoubts>>>
export type GetQuotationHasOpenDoubtsQueryError = ErrorType<unknown>


export function useGetQuotationHasOpenDoubts<TData = Awaited<ReturnType<typeof getQuotationHasOpenDoubts>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotationHasOpenDoubts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuotationHasOpenDoubts>>,
          TError,
          Awaited<ReturnType<typeof getQuotationHasOpenDoubts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetQuotationHasOpenDoubts<TData = Awaited<ReturnType<typeof getQuotationHasOpenDoubts>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotationHasOpenDoubts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuotationHasOpenDoubts>>,
          TError,
          Awaited<ReturnType<typeof getQuotationHasOpenDoubts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetQuotationHasOpenDoubts<TData = Awaited<ReturnType<typeof getQuotationHasOpenDoubts>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotationHasOpenDoubts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get quotation open doubts status
 */

export function useGetQuotationHasOpenDoubts<TData = Awaited<ReturnType<typeof getQuotationHasOpenDoubts>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotationHasOpenDoubts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetQuotationHasOpenDoubtsQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get quotation open doubts status
 */
export const prefetchGetQuotationHasOpenDoubtsQuery = async <TData = Awaited<ReturnType<typeof getQuotationHasOpenDoubts>>, TError = ErrorType<unknown>>(
 queryClient: QueryClient, id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotationHasOpenDoubts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = useGetQuotationHasOpenDoubtsQueryOptions(id,options)

  await queryClient.query(queryOptions).catch(() => {});

  return queryClient;
}

/**
 * @summary Invalidates the {@link useGetQuotationHasOpenDoubts} query
 */
export const invalidateGetQuotationHasOpenDoubts = async (
 queryClient: QueryClient, id: number, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: customQueryOptions({ queryKey: getGetQuotationHasOpenDoubtsQueryKey(id) }).queryKey }, options);

  return queryClient;
}




export const useGetQuotationHasOpenDoubtsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getQuotationHasOpenDoubts>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getQuotationHasOpenDoubts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetQuotationHasOpenDoubtsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getQuotationHasOpenDoubts>>> = ({ signal }) => getQuotationHasOpenDoubts(id, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, ...queryOptions});

   return  customOptions as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getQuotationHasOpenDoubts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetQuotationHasOpenDoubtsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getQuotationHasOpenDoubts>>>
export type GetQuotationHasOpenDoubtsSuspenseQueryError = ErrorType<unknown>


export function useGetQuotationHasOpenDoubtsSuspense<TData = Awaited<ReturnType<typeof getQuotationHasOpenDoubts>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getQuotationHasOpenDoubts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetQuotationHasOpenDoubtsSuspense<TData = Awaited<ReturnType<typeof getQuotationHasOpenDoubts>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getQuotationHasOpenDoubts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetQuotationHasOpenDoubtsSuspense<TData = Awaited<ReturnType<typeof getQuotationHasOpenDoubts>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getQuotationHasOpenDoubts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get quotation open doubts status
 */

export function useGetQuotationHasOpenDoubtsSuspense<TData = Awaited<ReturnType<typeof getQuotationHasOpenDoubts>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getQuotationHasOpenDoubts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetQuotationHasOpenDoubtsSuspenseQueryOptions(id,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useGetQuotationHasOpenDoubtsSuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getQuotationHasOpenDoubts>>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getQuotationHasOpenDoubts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetQuotationHasOpenDoubtsInfiniteQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getQuotationHasOpenDoubts>>> = ({ signal }) => getQuotationHasOpenDoubts(id, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, ...queryOptions});

   return  customOptions as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getQuotationHasOpenDoubts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetQuotationHasOpenDoubtsSuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getQuotationHasOpenDoubts>>>
export type GetQuotationHasOpenDoubtsSuspenseInfiniteQueryError = ErrorType<unknown>


export function useGetQuotationHasOpenDoubtsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getQuotationHasOpenDoubts>>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getQuotationHasOpenDoubts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetQuotationHasOpenDoubtsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getQuotationHasOpenDoubts>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getQuotationHasOpenDoubts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetQuotationHasOpenDoubtsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getQuotationHasOpenDoubts>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getQuotationHasOpenDoubts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get quotation open doubts status
 */

export function useGetQuotationHasOpenDoubtsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getQuotationHasOpenDoubts>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getQuotationHasOpenDoubts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetQuotationHasOpenDoubtsSuspenseInfiniteQueryOptions(id,options)

  const query = useSuspenseInfiniteQuery(queryOptions, queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Invite vendors to quotation
 */
export const inviteVendorsToQuotation = (
    id: number,
    inviteVendorsToQuotationRequest: InviteVendorsToQuotationRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<EntitiesQuotationMemberActionResult>(
      {url: `/api/v3/quotations/${id}/invite_vendors`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: inviteVendorsToQuotationRequest, signal
    },
      options);
    }




export const getInviteVendorsToQuotationMutationKey = () => ['inviteVendorsToQuotation'] as const;

export const getInviteVendorsToQuotationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof inviteVendorsToQuotation>>, TError,InviteVendorsToQuotationMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof inviteVendorsToQuotation>>, TError,InviteVendorsToQuotationMutationVariables, TContext> => {

const mutationKey = getInviteVendorsToQuotationMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof inviteVendorsToQuotation>>, InviteVendorsToQuotationMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  inviteVendorsToQuotation(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type InviteVendorsToQuotationMutationResult = NonNullable<Awaited<ReturnType<typeof inviteVendorsToQuotation>>>
    export type InviteVendorsToQuotationMutationBody = InviteVendorsToQuotationRequest
    export type InviteVendorsToQuotationMutationError = ErrorType<unknown>
    export type InviteVendorsToQuotationMutationVariables = {id: number;data: InviteVendorsToQuotationRequest}

    /**
 * @summary Invite vendors to quotation
 */
export const useInviteVendorsToQuotation = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof inviteVendorsToQuotation>>, TError,InviteVendorsToQuotationMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof inviteVendorsToQuotation>>,
        TError,
        InviteVendorsToQuotationMutationVariables,
        TContext
      > => {
      return useMutation(getInviteVendorsToQuotationMutationOptions(options), queryClient);
    }
    /**
 * @summary Change threat
 */
export const changeQuotationThreat = (
    id: number,
    changeQuotationThreatRequest: ChangeQuotationThreatRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<EntitiesQuotationMemberMain>(
      {url: `/api/v3/quotations/${id}/change_threat`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: changeQuotationThreatRequest, signal
    },
      options);
    }




export const getChangeQuotationThreatMutationKey = () => ['changeQuotationThreat'] as const;

export const getChangeQuotationThreatMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changeQuotationThreat>>, TError,ChangeQuotationThreatMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof changeQuotationThreat>>, TError,ChangeQuotationThreatMutationVariables, TContext> => {

const mutationKey = getChangeQuotationThreatMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof changeQuotationThreat>>, ChangeQuotationThreatMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  changeQuotationThreat(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ChangeQuotationThreatMutationResult = NonNullable<Awaited<ReturnType<typeof changeQuotationThreat>>>
    export type ChangeQuotationThreatMutationBody = ChangeQuotationThreatRequest
    export type ChangeQuotationThreatMutationError = ErrorType<unknown>
    export type ChangeQuotationThreatMutationVariables = {id: number;data: ChangeQuotationThreatRequest}

    /**
 * @summary Change threat
 */
export const useChangeQuotationThreat = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changeQuotationThreat>>, TError,ChangeQuotationThreatMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof changeQuotationThreat>>,
        TError,
        ChangeQuotationThreatMutationVariables,
        TContext
      > => {
      return useMutation(getChangeQuotationThreatMutationOptions(options), queryClient);
    }
    /**
 * @summary Update quotation observation
 */
export const updateQuotationObservation = (
    id: number,
    updateQuotationObservationRequest: UpdateQuotationObservationRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<EntitiesQuotationMemberActionResult>(
      {url: `/api/v3/quotations/${id}/observation`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateQuotationObservationRequest, signal
    },
      options);
    }




export const getUpdateQuotationObservationMutationKey = () => ['updateQuotationObservation'] as const;

export const getUpdateQuotationObservationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateQuotationObservation>>, TError,UpdateQuotationObservationMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateQuotationObservation>>, TError,UpdateQuotationObservationMutationVariables, TContext> => {

const mutationKey = getUpdateQuotationObservationMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateQuotationObservation>>, UpdateQuotationObservationMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateQuotationObservation(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateQuotationObservationMutationResult = NonNullable<Awaited<ReturnType<typeof updateQuotationObservation>>>
    export type UpdateQuotationObservationMutationBody = UpdateQuotationObservationRequest
    export type UpdateQuotationObservationMutationError = ErrorType<unknown>
    export type UpdateQuotationObservationMutationVariables = {id: number;data: UpdateQuotationObservationRequest}

    /**
 * @summary Update quotation observation
 */
export const useUpdateQuotationObservation = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateQuotationObservation>>, TError,UpdateQuotationObservationMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateQuotationObservation>>,
        TError,
        UpdateQuotationObservationMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateQuotationObservationMutationOptions(options), queryClient);
    }
    /**
 * @summary Update assigned user
 */
export const updateAssignedUser = (
    id: number,
    updateAssignedUserRequest: UpdateAssignedUserRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<EntitiesQuotationMemberActionResult>(
      {url: `/api/v3/quotations/${id}/assigned_to`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateAssignedUserRequest, signal
    },
      options);
    }




export const getUpdateAssignedUserMutationKey = () => ['updateAssignedUser'] as const;

export const getUpdateAssignedUserMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAssignedUser>>, TError,UpdateAssignedUserMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateAssignedUser>>, TError,UpdateAssignedUserMutationVariables, TContext> => {

const mutationKey = getUpdateAssignedUserMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAssignedUser>>, UpdateAssignedUserMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateAssignedUser(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateAssignedUserMutationResult = NonNullable<Awaited<ReturnType<typeof updateAssignedUser>>>
    export type UpdateAssignedUserMutationBody = UpdateAssignedUserRequest
    export type UpdateAssignedUserMutationError = ErrorType<unknown>
    export type UpdateAssignedUserMutationVariables = {id: number;data: UpdateAssignedUserRequest}

    /**
 * @summary Update assigned user
 */
export const useUpdateAssignedUser = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAssignedUser>>, TError,UpdateAssignedUserMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateAssignedUser>>,
        TError,
        UpdateAssignedUserMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateAssignedUserMutationOptions(options), queryClient);
    }
    /**
 * @summary Change assigned user (legacy path)
 */
export const changeAssignedUserLegacy = (
    id: number,
    changeAssignedUserLegacyRequest: ChangeAssignedUserLegacyRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<EntitiesQuotationMemberActionResult>(
      {url: `/api/v3/quotations/${id}/change_assigned_to`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: changeAssignedUserLegacyRequest, signal
    },
      options);
    }




export const getChangeAssignedUserLegacyMutationKey = () => ['changeAssignedUserLegacy'] as const;

export const getChangeAssignedUserLegacyMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changeAssignedUserLegacy>>, TError,ChangeAssignedUserLegacyMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof changeAssignedUserLegacy>>, TError,ChangeAssignedUserLegacyMutationVariables, TContext> => {

const mutationKey = getChangeAssignedUserLegacyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof changeAssignedUserLegacy>>, ChangeAssignedUserLegacyMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  changeAssignedUserLegacy(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ChangeAssignedUserLegacyMutationResult = NonNullable<Awaited<ReturnType<typeof changeAssignedUserLegacy>>>
    export type ChangeAssignedUserLegacyMutationBody = ChangeAssignedUserLegacyRequest
    export type ChangeAssignedUserLegacyMutationError = ErrorType<unknown>
    export type ChangeAssignedUserLegacyMutationVariables = {id: number;data: ChangeAssignedUserLegacyRequest}

    /**
 * @summary Change assigned user (legacy path)
 */
export const useChangeAssignedUserLegacy = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changeAssignedUserLegacy>>, TError,ChangeAssignedUserLegacyMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof changeAssignedUserLegacy>>,
        TError,
        ChangeAssignedUserLegacyMutationVariables,
        TContext
      > => {
      return useMutation(getChangeAssignedUserLegacyMutationOptions(options), queryClient);
    }
    /**
 * @summary Refuse quotation
 */
export const refuseQuotation = (
    id: number,
    refuseQuotationRequest: RefuseQuotationRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<EntitiesQuotationMemberActionResult>(
      {url: `/api/v3/quotations/${id}/refuse`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: refuseQuotationRequest, signal
    },
      options);
    }




export const getRefuseQuotationMutationKey = () => ['refuseQuotation'] as const;

export const getRefuseQuotationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refuseQuotation>>, TError,RefuseQuotationMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof refuseQuotation>>, TError,RefuseQuotationMutationVariables, TContext> => {

const mutationKey = getRefuseQuotationMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof refuseQuotation>>, RefuseQuotationMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  refuseQuotation(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RefuseQuotationMutationResult = NonNullable<Awaited<ReturnType<typeof refuseQuotation>>>
    export type RefuseQuotationMutationBody = RefuseQuotationRequest
    export type RefuseQuotationMutationError = ErrorType<unknown>
    export type RefuseQuotationMutationVariables = {id: number;data: RefuseQuotationRequest}

    /**
 * @summary Refuse quotation
 */
export const useRefuseQuotation = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refuseQuotation>>, TError,RefuseQuotationMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof refuseQuotation>>,
        TError,
        RefuseQuotationMutationVariables,
        TContext
      > => {
      return useMutation(getRefuseQuotationMutationOptions(options), queryClient);
    }
    /**
 * @summary Cancel or recreate quotation
 */
export const cancelOrRecreateQuotation = (
    id: number,
    cancelOrRecreateQuotationRequest: CancelOrRecreateQuotationRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<EntitiesQuotationMemberActionResult>(
      {url: `/api/v3/quotations/${id}/cancel`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: cancelOrRecreateQuotationRequest, signal
    },
      options);
    }




export const getCancelOrRecreateQuotationMutationKey = () => ['cancelOrRecreateQuotation'] as const;

export const getCancelOrRecreateQuotationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelOrRecreateQuotation>>, TError,CancelOrRecreateQuotationMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof cancelOrRecreateQuotation>>, TError,CancelOrRecreateQuotationMutationVariables, TContext> => {

const mutationKey = getCancelOrRecreateQuotationMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelOrRecreateQuotation>>, CancelOrRecreateQuotationMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  cancelOrRecreateQuotation(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CancelOrRecreateQuotationMutationResult = NonNullable<Awaited<ReturnType<typeof cancelOrRecreateQuotation>>>
    export type CancelOrRecreateQuotationMutationBody = CancelOrRecreateQuotationRequest
    export type CancelOrRecreateQuotationMutationError = ErrorType<unknown>
    export type CancelOrRecreateQuotationMutationVariables = {id: number;data: CancelOrRecreateQuotationRequest}

    /**
 * @summary Cancel or recreate quotation
 */
export const useCancelOrRecreateQuotation = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelOrRecreateQuotation>>, TError,CancelOrRecreateQuotationMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cancelOrRecreateQuotation>>,
        TError,
        CancelOrRecreateQuotationMutationVariables,
        TContext
      > => {
      return useMutation(getCancelOrRecreateQuotationMutationOptions(options), queryClient);
    }
    /**
 * @summary Add/Remove threat classification
 */
export const changeThreatClassification = (
    id: number,
    changeThreatClassificationRequest: ChangeThreatClassificationRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<EntitiesQuotationMemberActionResult>(
      {url: `/api/v3/quotations/${id}/threat_classification`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: changeThreatClassificationRequest, signal
    },
      options);
    }




export const getChangeThreatClassificationMutationKey = () => ['changeThreatClassification'] as const;

export const getChangeThreatClassificationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changeThreatClassification>>, TError,ChangeThreatClassificationMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof changeThreatClassification>>, TError,ChangeThreatClassificationMutationVariables, TContext> => {

const mutationKey = getChangeThreatClassificationMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof changeThreatClassification>>, ChangeThreatClassificationMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  changeThreatClassification(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ChangeThreatClassificationMutationResult = NonNullable<Awaited<ReturnType<typeof changeThreatClassification>>>
    export type ChangeThreatClassificationMutationBody = ChangeThreatClassificationRequest
    export type ChangeThreatClassificationMutationError = ErrorType<unknown>
    export type ChangeThreatClassificationMutationVariables = {id: number;data: ChangeThreatClassificationRequest}

    /**
 * @summary Add/Remove threat classification
 */
export const useChangeThreatClassification = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changeThreatClassification>>, TError,ChangeThreatClassificationMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof changeThreatClassification>>,
        TError,
        ChangeThreatClassificationMutationVariables,
        TContext
      > => {
      return useMutation(getChangeThreatClassificationMutationOptions(options), queryClient);
    }
    /**
 * @summary Get quotation activity
 */
export const getQuotationActivity = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<EntitiesQuotationMemberActivity>(
      {url: `/api/v3/quotations/${id}/activity`, method: 'GET', signal
    },
      options);
    }




export const getGetQuotationActivityInfiniteQueryKey = (id: number,) => {
    return [
    'infinite', `/api/v3/quotations/${id}/activity`
    ] as const;
    }

export const getGetQuotationActivityQueryKey = (id: number,) => {
    return [
    `/api/v3/quotations/${id}/activity`
    ] as const;
    }


export const useGetQuotationActivityInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getQuotationActivity>>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getQuotationActivity>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetQuotationActivityInfiniteQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getQuotationActivity>>> = ({ signal }) => getQuotationActivity(id, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions});

   return  customOptions as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getQuotationActivity>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetQuotationActivityInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getQuotationActivity>>>
export type GetQuotationActivityInfiniteQueryError = ErrorType<unknown>


export function useGetQuotationActivityInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getQuotationActivity>>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getQuotationActivity>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuotationActivity>>,
          TError,
          Awaited<ReturnType<typeof getQuotationActivity>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetQuotationActivityInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getQuotationActivity>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getQuotationActivity>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuotationActivity>>,
          TError,
          Awaited<ReturnType<typeof getQuotationActivity>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetQuotationActivityInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getQuotationActivity>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getQuotationActivity>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get quotation activity
 */

export function useGetQuotationActivityInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getQuotationActivity>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getQuotationActivity>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetQuotationActivityInfiniteQueryOptions(id,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get quotation activity
 */
export const prefetchGetQuotationActivityInfiniteQuery = async <TData = Awaited<ReturnType<typeof getQuotationActivity>>, TError = ErrorType<unknown>>(
 queryClient: QueryClient, id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getQuotationActivity>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = useGetQuotationActivityInfiniteQueryOptions(id,options)

  await queryClient.infiniteQuery(queryOptions).catch(() => {});

  return queryClient;
}

/**
 * @summary Invalidates the {@link useGetQuotationActivityInfinite} query
 */
export const invalidateGetQuotationActivityInfinite = async (
 queryClient: QueryClient, id: number, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: customQueryOptions({ queryKey: getGetQuotationActivityInfiniteQueryKey(id) }).queryKey }, options);

  return queryClient;
}




export const useGetQuotationActivityQueryOptions = <TData = Awaited<ReturnType<typeof getQuotationActivity>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotationActivity>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetQuotationActivityQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getQuotationActivity>>> = ({ signal }) => getQuotationActivity(id, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof getQuotationActivity>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetQuotationActivityQueryResult = NonNullable<Awaited<ReturnType<typeof getQuotationActivity>>>
export type GetQuotationActivityQueryError = ErrorType<unknown>


export function useGetQuotationActivity<TData = Awaited<ReturnType<typeof getQuotationActivity>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotationActivity>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuotationActivity>>,
          TError,
          Awaited<ReturnType<typeof getQuotationActivity>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetQuotationActivity<TData = Awaited<ReturnType<typeof getQuotationActivity>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotationActivity>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuotationActivity>>,
          TError,
          Awaited<ReturnType<typeof getQuotationActivity>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetQuotationActivity<TData = Awaited<ReturnType<typeof getQuotationActivity>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotationActivity>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get quotation activity
 */

export function useGetQuotationActivity<TData = Awaited<ReturnType<typeof getQuotationActivity>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotationActivity>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetQuotationActivityQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get quotation activity
 */
export const prefetchGetQuotationActivityQuery = async <TData = Awaited<ReturnType<typeof getQuotationActivity>>, TError = ErrorType<unknown>>(
 queryClient: QueryClient, id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotationActivity>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = useGetQuotationActivityQueryOptions(id,options)

  await queryClient.query(queryOptions).catch(() => {});

  return queryClient;
}

/**
 * @summary Invalidates the {@link useGetQuotationActivity} query
 */
export const invalidateGetQuotationActivity = async (
 queryClient: QueryClient, id: number, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: customQueryOptions({ queryKey: getGetQuotationActivityQueryKey(id) }).queryKey }, options);

  return queryClient;
}




export const useGetQuotationActivitySuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getQuotationActivity>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getQuotationActivity>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetQuotationActivityQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getQuotationActivity>>> = ({ signal }) => getQuotationActivity(id, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, ...queryOptions});

   return  customOptions as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getQuotationActivity>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetQuotationActivitySuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getQuotationActivity>>>
export type GetQuotationActivitySuspenseQueryError = ErrorType<unknown>


export function useGetQuotationActivitySuspense<TData = Awaited<ReturnType<typeof getQuotationActivity>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getQuotationActivity>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetQuotationActivitySuspense<TData = Awaited<ReturnType<typeof getQuotationActivity>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getQuotationActivity>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetQuotationActivitySuspense<TData = Awaited<ReturnType<typeof getQuotationActivity>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getQuotationActivity>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get quotation activity
 */

export function useGetQuotationActivitySuspense<TData = Awaited<ReturnType<typeof getQuotationActivity>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getQuotationActivity>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetQuotationActivitySuspenseQueryOptions(id,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useGetQuotationActivitySuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getQuotationActivity>>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getQuotationActivity>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetQuotationActivityInfiniteQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getQuotationActivity>>> = ({ signal }) => getQuotationActivity(id, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, ...queryOptions});

   return  customOptions as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getQuotationActivity>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetQuotationActivitySuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getQuotationActivity>>>
export type GetQuotationActivitySuspenseInfiniteQueryError = ErrorType<unknown>


export function useGetQuotationActivitySuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getQuotationActivity>>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getQuotationActivity>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetQuotationActivitySuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getQuotationActivity>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getQuotationActivity>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetQuotationActivitySuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getQuotationActivity>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getQuotationActivity>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get quotation activity
 */

export function useGetQuotationActivitySuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getQuotationActivity>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getQuotationActivity>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetQuotationActivitySuspenseInfiniteQueryOptions(id,options)

  const query = useSuspenseInfiniteQuery(queryOptions, queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary List quotation files
 */
export const listQuotationFiles = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<EntitiesQuotationMemberFilesResponse>(
      {url: `/api/v3/quotations/${id}/files`, method: 'GET', signal
    },
      options);
    }




export const getListQuotationFilesInfiniteQueryKey = (id: number,) => {
    return [
    'infinite', `/api/v3/quotations/${id}/files`
    ] as const;
    }

export const getListQuotationFilesQueryKey = (id: number,) => {
    return [
    `/api/v3/quotations/${id}/files`
    ] as const;
    }


export const useListQuotationFilesInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof listQuotationFiles>>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listQuotationFiles>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListQuotationFilesInfiniteQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listQuotationFiles>>> = ({ signal }) => listQuotationFiles(id, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions});

   return  customOptions as UseInfiniteQueryOptions<Awaited<ReturnType<typeof listQuotationFiles>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListQuotationFilesInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof listQuotationFiles>>>
export type ListQuotationFilesInfiniteQueryError = ErrorType<unknown>


export function useListQuotationFilesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listQuotationFiles>>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listQuotationFiles>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listQuotationFiles>>,
          TError,
          Awaited<ReturnType<typeof listQuotationFiles>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListQuotationFilesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listQuotationFiles>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listQuotationFiles>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listQuotationFiles>>,
          TError,
          Awaited<ReturnType<typeof listQuotationFiles>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListQuotationFilesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listQuotationFiles>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listQuotationFiles>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List quotation files
 */

export function useListQuotationFilesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listQuotationFiles>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listQuotationFiles>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListQuotationFilesInfiniteQueryOptions(id,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List quotation files
 */
export const prefetchListQuotationFilesInfiniteQuery = async <TData = Awaited<ReturnType<typeof listQuotationFiles>>, TError = ErrorType<unknown>>(
 queryClient: QueryClient, id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listQuotationFiles>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = useListQuotationFilesInfiniteQueryOptions(id,options)

  await queryClient.infiniteQuery(queryOptions).catch(() => {});

  return queryClient;
}

/**
 * @summary Invalidates the {@link useListQuotationFilesInfinite} query
 */
export const invalidateListQuotationFilesInfinite = async (
 queryClient: QueryClient, id: number, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: customQueryOptions({ queryKey: getListQuotationFilesInfiniteQueryKey(id) }).queryKey }, options);

  return queryClient;
}




export const useListQuotationFilesQueryOptions = <TData = Awaited<ReturnType<typeof listQuotationFiles>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listQuotationFiles>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListQuotationFilesQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listQuotationFiles>>> = ({ signal }) => listQuotationFiles(id, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof listQuotationFiles>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListQuotationFilesQueryResult = NonNullable<Awaited<ReturnType<typeof listQuotationFiles>>>
export type ListQuotationFilesQueryError = ErrorType<unknown>


export function useListQuotationFiles<TData = Awaited<ReturnType<typeof listQuotationFiles>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listQuotationFiles>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listQuotationFiles>>,
          TError,
          Awaited<ReturnType<typeof listQuotationFiles>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListQuotationFiles<TData = Awaited<ReturnType<typeof listQuotationFiles>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listQuotationFiles>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listQuotationFiles>>,
          TError,
          Awaited<ReturnType<typeof listQuotationFiles>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListQuotationFiles<TData = Awaited<ReturnType<typeof listQuotationFiles>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listQuotationFiles>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List quotation files
 */

export function useListQuotationFiles<TData = Awaited<ReturnType<typeof listQuotationFiles>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listQuotationFiles>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListQuotationFilesQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List quotation files
 */
export const prefetchListQuotationFilesQuery = async <TData = Awaited<ReturnType<typeof listQuotationFiles>>, TError = ErrorType<unknown>>(
 queryClient: QueryClient, id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listQuotationFiles>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = useListQuotationFilesQueryOptions(id,options)

  await queryClient.query(queryOptions).catch(() => {});

  return queryClient;
}

/**
 * @summary Invalidates the {@link useListQuotationFiles} query
 */
export const invalidateListQuotationFiles = async (
 queryClient: QueryClient, id: number, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: customQueryOptions({ queryKey: getListQuotationFilesQueryKey(id) }).queryKey }, options);

  return queryClient;
}




export const useListQuotationFilesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listQuotationFiles>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listQuotationFiles>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListQuotationFilesQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listQuotationFiles>>> = ({ signal }) => listQuotationFiles(id, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, ...queryOptions});

   return  customOptions as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listQuotationFiles>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListQuotationFilesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listQuotationFiles>>>
export type ListQuotationFilesSuspenseQueryError = ErrorType<unknown>


export function useListQuotationFilesSuspense<TData = Awaited<ReturnType<typeof listQuotationFiles>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listQuotationFiles>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListQuotationFilesSuspense<TData = Awaited<ReturnType<typeof listQuotationFiles>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listQuotationFiles>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListQuotationFilesSuspense<TData = Awaited<ReturnType<typeof listQuotationFiles>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listQuotationFiles>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List quotation files
 */

export function useListQuotationFilesSuspense<TData = Awaited<ReturnType<typeof listQuotationFiles>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listQuotationFiles>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListQuotationFilesSuspenseQueryOptions(id,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useListQuotationFilesSuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof listQuotationFiles>>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof listQuotationFiles>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListQuotationFilesInfiniteQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listQuotationFiles>>> = ({ signal }) => listQuotationFiles(id, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, ...queryOptions});

   return  customOptions as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof listQuotationFiles>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListQuotationFilesSuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof listQuotationFiles>>>
export type ListQuotationFilesSuspenseInfiniteQueryError = ErrorType<unknown>


export function useListQuotationFilesSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listQuotationFiles>>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof listQuotationFiles>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListQuotationFilesSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listQuotationFiles>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof listQuotationFiles>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListQuotationFilesSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listQuotationFiles>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof listQuotationFiles>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List quotation files
 */

export function useListQuotationFilesSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listQuotationFiles>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof listQuotationFiles>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListQuotationFilesSuspenseInfiniteQueryOptions(id,options)

  const query = useSuspenseInfiniteQuery(queryOptions, queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Add an observation document to a quotation
 */
export const addQuotationObservationDocument = (
    id: number,
    addQuotationObservationDocumentRequest: AddQuotationObservationDocumentRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<EntitiesQuotationMemberActionResult>(
      {url: `/api/v3/quotations/${id}/files`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: addQuotationObservationDocumentRequest, signal
    },
      options);
    }




export const getAddQuotationObservationDocumentMutationKey = () => ['addQuotationObservationDocument'] as const;

export const getAddQuotationObservationDocumentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addQuotationObservationDocument>>, TError,AddQuotationObservationDocumentMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof addQuotationObservationDocument>>, TError,AddQuotationObservationDocumentMutationVariables, TContext> => {

const mutationKey = getAddQuotationObservationDocumentMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addQuotationObservationDocument>>, AddQuotationObservationDocumentMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  addQuotationObservationDocument(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddQuotationObservationDocumentMutationResult = NonNullable<Awaited<ReturnType<typeof addQuotationObservationDocument>>>
    export type AddQuotationObservationDocumentMutationBody = AddQuotationObservationDocumentRequest
    export type AddQuotationObservationDocumentMutationError = ErrorType<unknown>
    export type AddQuotationObservationDocumentMutationVariables = {id: number;data: AddQuotationObservationDocumentRequest}

    /**
 * @summary Add an observation document to a quotation
 */
export const useAddQuotationObservationDocument = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addQuotationObservationDocument>>, TError,AddQuotationObservationDocumentMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof addQuotationObservationDocument>>,
        TError,
        AddQuotationObservationDocumentMutationVariables,
        TContext
      > => {
      return useMutation(getAddQuotationObservationDocumentMutationOptions(options), queryClient);
    }
    /**
 * @summary Remove an observation document from a quotation
 */
export const removeQuotationObservationDocument = (
    id: number,
    fileId: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<EntitiesQuotationMemberActionResult>(
      {url: `/api/v3/quotations/${id}/files/${fileId}`, method: 'DELETE', signal
    },
      options);
    }




export const getRemoveQuotationObservationDocumentMutationKey = () => ['removeQuotationObservationDocument'] as const;

export const getRemoveQuotationObservationDocumentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeQuotationObservationDocument>>, TError,RemoveQuotationObservationDocumentMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof removeQuotationObservationDocument>>, TError,RemoveQuotationObservationDocumentMutationVariables, TContext> => {

const mutationKey = getRemoveQuotationObservationDocumentMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeQuotationObservationDocument>>, RemoveQuotationObservationDocumentMutationVariables> = (props) => {
          const {id,fileId} = props ?? {};

          return  removeQuotationObservationDocument(id,fileId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemoveQuotationObservationDocumentMutationResult = NonNullable<Awaited<ReturnType<typeof removeQuotationObservationDocument>>>

    export type RemoveQuotationObservationDocumentMutationError = ErrorType<unknown>
    export type RemoveQuotationObservationDocumentMutationVariables = {id: number;fileId: number}

    /**
 * @summary Remove an observation document from a quotation
 */
export const useRemoveQuotationObservationDocument = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeQuotationObservationDocument>>, TError,RemoveQuotationObservationDocumentMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof removeQuotationObservationDocument>>,
        TError,
        RemoveQuotationObservationDocumentMutationVariables,
        TContext
      > => {
      return useMutation(getRemoveQuotationObservationDocumentMutationOptions(options), queryClient);
    }
    /**
 * @summary Check allowed actions for quotation
 */
export const getQuotationAllowedActions = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<EntitiesQuotationMemberAllowedActions>(
      {url: `/api/v3/quotations/${id}/allowed_actions`, method: 'GET', signal
    },
      options);
    }




export const getGetQuotationAllowedActionsInfiniteQueryKey = (id: number,) => {
    return [
    'infinite', `/api/v3/quotations/${id}/allowed_actions`
    ] as const;
    }

export const getGetQuotationAllowedActionsQueryKey = (id: number,) => {
    return [
    `/api/v3/quotations/${id}/allowed_actions`
    ] as const;
    }


export const useGetQuotationAllowedActionsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getQuotationAllowedActions>>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getQuotationAllowedActions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetQuotationAllowedActionsInfiniteQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getQuotationAllowedActions>>> = ({ signal }) => getQuotationAllowedActions(id, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions});

   return  customOptions as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getQuotationAllowedActions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetQuotationAllowedActionsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getQuotationAllowedActions>>>
export type GetQuotationAllowedActionsInfiniteQueryError = ErrorType<unknown>


export function useGetQuotationAllowedActionsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getQuotationAllowedActions>>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getQuotationAllowedActions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuotationAllowedActions>>,
          TError,
          Awaited<ReturnType<typeof getQuotationAllowedActions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetQuotationAllowedActionsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getQuotationAllowedActions>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getQuotationAllowedActions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuotationAllowedActions>>,
          TError,
          Awaited<ReturnType<typeof getQuotationAllowedActions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetQuotationAllowedActionsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getQuotationAllowedActions>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getQuotationAllowedActions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Check allowed actions for quotation
 */

export function useGetQuotationAllowedActionsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getQuotationAllowedActions>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getQuotationAllowedActions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetQuotationAllowedActionsInfiniteQueryOptions(id,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Check allowed actions for quotation
 */
export const prefetchGetQuotationAllowedActionsInfiniteQuery = async <TData = Awaited<ReturnType<typeof getQuotationAllowedActions>>, TError = ErrorType<unknown>>(
 queryClient: QueryClient, id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getQuotationAllowedActions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = useGetQuotationAllowedActionsInfiniteQueryOptions(id,options)

  await queryClient.infiniteQuery(queryOptions).catch(() => {});

  return queryClient;
}

/**
 * @summary Invalidates the {@link useGetQuotationAllowedActionsInfinite} query
 */
export const invalidateGetQuotationAllowedActionsInfinite = async (
 queryClient: QueryClient, id: number, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: customQueryOptions({ queryKey: getGetQuotationAllowedActionsInfiniteQueryKey(id) }).queryKey }, options);

  return queryClient;
}




export const useGetQuotationAllowedActionsQueryOptions = <TData = Awaited<ReturnType<typeof getQuotationAllowedActions>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotationAllowedActions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetQuotationAllowedActionsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getQuotationAllowedActions>>> = ({ signal }) => getQuotationAllowedActions(id, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof getQuotationAllowedActions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetQuotationAllowedActionsQueryResult = NonNullable<Awaited<ReturnType<typeof getQuotationAllowedActions>>>
export type GetQuotationAllowedActionsQueryError = ErrorType<unknown>


export function useGetQuotationAllowedActions<TData = Awaited<ReturnType<typeof getQuotationAllowedActions>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotationAllowedActions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuotationAllowedActions>>,
          TError,
          Awaited<ReturnType<typeof getQuotationAllowedActions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetQuotationAllowedActions<TData = Awaited<ReturnType<typeof getQuotationAllowedActions>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotationAllowedActions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuotationAllowedActions>>,
          TError,
          Awaited<ReturnType<typeof getQuotationAllowedActions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetQuotationAllowedActions<TData = Awaited<ReturnType<typeof getQuotationAllowedActions>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotationAllowedActions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Check allowed actions for quotation
 */

export function useGetQuotationAllowedActions<TData = Awaited<ReturnType<typeof getQuotationAllowedActions>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotationAllowedActions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetQuotationAllowedActionsQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Check allowed actions for quotation
 */
export const prefetchGetQuotationAllowedActionsQuery = async <TData = Awaited<ReturnType<typeof getQuotationAllowedActions>>, TError = ErrorType<unknown>>(
 queryClient: QueryClient, id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotationAllowedActions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = useGetQuotationAllowedActionsQueryOptions(id,options)

  await queryClient.query(queryOptions).catch(() => {});

  return queryClient;
}

/**
 * @summary Invalidates the {@link useGetQuotationAllowedActions} query
 */
export const invalidateGetQuotationAllowedActions = async (
 queryClient: QueryClient, id: number, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: customQueryOptions({ queryKey: getGetQuotationAllowedActionsQueryKey(id) }).queryKey }, options);

  return queryClient;
}




export const useGetQuotationAllowedActionsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getQuotationAllowedActions>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getQuotationAllowedActions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetQuotationAllowedActionsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getQuotationAllowedActions>>> = ({ signal }) => getQuotationAllowedActions(id, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, ...queryOptions});

   return  customOptions as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getQuotationAllowedActions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetQuotationAllowedActionsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getQuotationAllowedActions>>>
export type GetQuotationAllowedActionsSuspenseQueryError = ErrorType<unknown>


export function useGetQuotationAllowedActionsSuspense<TData = Awaited<ReturnType<typeof getQuotationAllowedActions>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getQuotationAllowedActions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetQuotationAllowedActionsSuspense<TData = Awaited<ReturnType<typeof getQuotationAllowedActions>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getQuotationAllowedActions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetQuotationAllowedActionsSuspense<TData = Awaited<ReturnType<typeof getQuotationAllowedActions>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getQuotationAllowedActions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Check allowed actions for quotation
 */

export function useGetQuotationAllowedActionsSuspense<TData = Awaited<ReturnType<typeof getQuotationAllowedActions>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getQuotationAllowedActions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetQuotationAllowedActionsSuspenseQueryOptions(id,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useGetQuotationAllowedActionsSuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getQuotationAllowedActions>>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getQuotationAllowedActions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetQuotationAllowedActionsInfiniteQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getQuotationAllowedActions>>> = ({ signal }) => getQuotationAllowedActions(id, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, ...queryOptions});

   return  customOptions as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getQuotationAllowedActions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetQuotationAllowedActionsSuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getQuotationAllowedActions>>>
export type GetQuotationAllowedActionsSuspenseInfiniteQueryError = ErrorType<unknown>


export function useGetQuotationAllowedActionsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getQuotationAllowedActions>>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getQuotationAllowedActions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetQuotationAllowedActionsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getQuotationAllowedActions>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getQuotationAllowedActions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetQuotationAllowedActionsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getQuotationAllowedActions>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getQuotationAllowedActions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Check allowed actions for quotation
 */

export function useGetQuotationAllowedActionsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getQuotationAllowedActions>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getQuotationAllowedActions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetQuotationAllowedActionsSuspenseInfiniteQueryOptions(id,options)

  const query = useSuspenseInfiniteQuery(queryOptions, queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Check available actions for quotation (legacy path)
 */
export const getQuotationAvailableActionsLegacy = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<EntitiesQuotationMemberAllowedActions>(
      {url: `/api/v3/quotations/${id}/available_actions`, method: 'GET', signal
    },
      options);
    }




export const getGetQuotationAvailableActionsLegacyInfiniteQueryKey = (id: number,) => {
    return [
    'infinite', `/api/v3/quotations/${id}/available_actions`
    ] as const;
    }

export const getGetQuotationAvailableActionsLegacyQueryKey = (id: number,) => {
    return [
    `/api/v3/quotations/${id}/available_actions`
    ] as const;
    }


export const useGetQuotationAvailableActionsLegacyInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getQuotationAvailableActionsLegacy>>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getQuotationAvailableActionsLegacy>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetQuotationAvailableActionsLegacyInfiniteQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getQuotationAvailableActionsLegacy>>> = ({ signal }) => getQuotationAvailableActionsLegacy(id, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions});

   return  customOptions as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getQuotationAvailableActionsLegacy>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetQuotationAvailableActionsLegacyInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getQuotationAvailableActionsLegacy>>>
export type GetQuotationAvailableActionsLegacyInfiniteQueryError = ErrorType<unknown>


export function useGetQuotationAvailableActionsLegacyInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getQuotationAvailableActionsLegacy>>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getQuotationAvailableActionsLegacy>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuotationAvailableActionsLegacy>>,
          TError,
          Awaited<ReturnType<typeof getQuotationAvailableActionsLegacy>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetQuotationAvailableActionsLegacyInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getQuotationAvailableActionsLegacy>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getQuotationAvailableActionsLegacy>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuotationAvailableActionsLegacy>>,
          TError,
          Awaited<ReturnType<typeof getQuotationAvailableActionsLegacy>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetQuotationAvailableActionsLegacyInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getQuotationAvailableActionsLegacy>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getQuotationAvailableActionsLegacy>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Check available actions for quotation (legacy path)
 */

export function useGetQuotationAvailableActionsLegacyInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getQuotationAvailableActionsLegacy>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getQuotationAvailableActionsLegacy>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetQuotationAvailableActionsLegacyInfiniteQueryOptions(id,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Check available actions for quotation (legacy path)
 */
export const prefetchGetQuotationAvailableActionsLegacyInfiniteQuery = async <TData = Awaited<ReturnType<typeof getQuotationAvailableActionsLegacy>>, TError = ErrorType<unknown>>(
 queryClient: QueryClient, id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getQuotationAvailableActionsLegacy>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = useGetQuotationAvailableActionsLegacyInfiniteQueryOptions(id,options)

  await queryClient.infiniteQuery(queryOptions).catch(() => {});

  return queryClient;
}

/**
 * @summary Invalidates the {@link useGetQuotationAvailableActionsLegacyInfinite} query
 */
export const invalidateGetQuotationAvailableActionsLegacyInfinite = async (
 queryClient: QueryClient, id: number, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: customQueryOptions({ queryKey: getGetQuotationAvailableActionsLegacyInfiniteQueryKey(id) }).queryKey }, options);

  return queryClient;
}




export const useGetQuotationAvailableActionsLegacyQueryOptions = <TData = Awaited<ReturnType<typeof getQuotationAvailableActionsLegacy>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotationAvailableActionsLegacy>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetQuotationAvailableActionsLegacyQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getQuotationAvailableActionsLegacy>>> = ({ signal }) => getQuotationAvailableActionsLegacy(id, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof getQuotationAvailableActionsLegacy>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetQuotationAvailableActionsLegacyQueryResult = NonNullable<Awaited<ReturnType<typeof getQuotationAvailableActionsLegacy>>>
export type GetQuotationAvailableActionsLegacyQueryError = ErrorType<unknown>


export function useGetQuotationAvailableActionsLegacy<TData = Awaited<ReturnType<typeof getQuotationAvailableActionsLegacy>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotationAvailableActionsLegacy>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuotationAvailableActionsLegacy>>,
          TError,
          Awaited<ReturnType<typeof getQuotationAvailableActionsLegacy>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetQuotationAvailableActionsLegacy<TData = Awaited<ReturnType<typeof getQuotationAvailableActionsLegacy>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotationAvailableActionsLegacy>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuotationAvailableActionsLegacy>>,
          TError,
          Awaited<ReturnType<typeof getQuotationAvailableActionsLegacy>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetQuotationAvailableActionsLegacy<TData = Awaited<ReturnType<typeof getQuotationAvailableActionsLegacy>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotationAvailableActionsLegacy>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Check available actions for quotation (legacy path)
 */

export function useGetQuotationAvailableActionsLegacy<TData = Awaited<ReturnType<typeof getQuotationAvailableActionsLegacy>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotationAvailableActionsLegacy>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetQuotationAvailableActionsLegacyQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Check available actions for quotation (legacy path)
 */
export const prefetchGetQuotationAvailableActionsLegacyQuery = async <TData = Awaited<ReturnType<typeof getQuotationAvailableActionsLegacy>>, TError = ErrorType<unknown>>(
 queryClient: QueryClient, id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotationAvailableActionsLegacy>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = useGetQuotationAvailableActionsLegacyQueryOptions(id,options)

  await queryClient.query(queryOptions).catch(() => {});

  return queryClient;
}

/**
 * @summary Invalidates the {@link useGetQuotationAvailableActionsLegacy} query
 */
export const invalidateGetQuotationAvailableActionsLegacy = async (
 queryClient: QueryClient, id: number, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: customQueryOptions({ queryKey: getGetQuotationAvailableActionsLegacyQueryKey(id) }).queryKey }, options);

  return queryClient;
}




export const useGetQuotationAvailableActionsLegacySuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getQuotationAvailableActionsLegacy>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getQuotationAvailableActionsLegacy>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetQuotationAvailableActionsLegacyQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getQuotationAvailableActionsLegacy>>> = ({ signal }) => getQuotationAvailableActionsLegacy(id, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, ...queryOptions});

   return  customOptions as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getQuotationAvailableActionsLegacy>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetQuotationAvailableActionsLegacySuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getQuotationAvailableActionsLegacy>>>
export type GetQuotationAvailableActionsLegacySuspenseQueryError = ErrorType<unknown>


export function useGetQuotationAvailableActionsLegacySuspense<TData = Awaited<ReturnType<typeof getQuotationAvailableActionsLegacy>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getQuotationAvailableActionsLegacy>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetQuotationAvailableActionsLegacySuspense<TData = Awaited<ReturnType<typeof getQuotationAvailableActionsLegacy>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getQuotationAvailableActionsLegacy>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetQuotationAvailableActionsLegacySuspense<TData = Awaited<ReturnType<typeof getQuotationAvailableActionsLegacy>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getQuotationAvailableActionsLegacy>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Check available actions for quotation (legacy path)
 */

export function useGetQuotationAvailableActionsLegacySuspense<TData = Awaited<ReturnType<typeof getQuotationAvailableActionsLegacy>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getQuotationAvailableActionsLegacy>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetQuotationAvailableActionsLegacySuspenseQueryOptions(id,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useGetQuotationAvailableActionsLegacySuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getQuotationAvailableActionsLegacy>>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getQuotationAvailableActionsLegacy>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetQuotationAvailableActionsLegacyInfiniteQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getQuotationAvailableActionsLegacy>>> = ({ signal }) => getQuotationAvailableActionsLegacy(id, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, ...queryOptions});

   return  customOptions as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getQuotationAvailableActionsLegacy>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetQuotationAvailableActionsLegacySuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getQuotationAvailableActionsLegacy>>>
export type GetQuotationAvailableActionsLegacySuspenseInfiniteQueryError = ErrorType<unknown>


export function useGetQuotationAvailableActionsLegacySuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getQuotationAvailableActionsLegacy>>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getQuotationAvailableActionsLegacy>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetQuotationAvailableActionsLegacySuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getQuotationAvailableActionsLegacy>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getQuotationAvailableActionsLegacy>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetQuotationAvailableActionsLegacySuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getQuotationAvailableActionsLegacy>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getQuotationAvailableActionsLegacy>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Check available actions for quotation (legacy path)
 */

export function useGetQuotationAvailableActionsLegacySuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getQuotationAvailableActionsLegacy>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getQuotationAvailableActionsLegacy>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetQuotationAvailableActionsLegacySuspenseInfiniteQueryOptions(id,options)

  const query = useSuspenseInfiniteQuery(queryOptions, queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Recreate assisted quotation by PR item difference
 */
export const recreateByPrItemDifference = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<EntitiesQuotationMemberActionResult>(
      {url: `/api/v3/quotations/${id}/recreate_by_pr_item_difference`, method: 'POST', signal
    },
      options);
    }




export const getRecreateByPrItemDifferenceMutationKey = () => ['recreateByPrItemDifference'] as const;

export const getRecreateByPrItemDifferenceMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recreateByPrItemDifference>>, TError,RecreateByPrItemDifferenceMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof recreateByPrItemDifference>>, TError,RecreateByPrItemDifferenceMutationVariables, TContext> => {

const mutationKey = getRecreateByPrItemDifferenceMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof recreateByPrItemDifference>>, RecreateByPrItemDifferenceMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  recreateByPrItemDifference(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RecreateByPrItemDifferenceMutationResult = NonNullable<Awaited<ReturnType<typeof recreateByPrItemDifference>>>

    export type RecreateByPrItemDifferenceMutationError = ErrorType<unknown>
    export type RecreateByPrItemDifferenceMutationVariables = {id: number}

    /**
 * @summary Recreate assisted quotation by PR item difference
 */
export const useRecreateByPrItemDifference = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recreateByPrItemDifference>>, TError,RecreateByPrItemDifferenceMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof recreateByPrItemDifference>>,
        TError,
        RecreateByPrItemDifferenceMutationVariables,
        TContext
      > => {
      return useMutation(getRecreateByPrItemDifferenceMutationOptions(options), queryClient);
    }
    /**
 * @summary Remove create purchase order by quotation
 */
export const removeCreatePurchaseOrderByQuotation = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<EntitiesQuotationMemberActionResult>(
      {url: `/api/v3/quotations/${id}/remove_create_purchase_order_by_quotation`, method: 'DELETE', signal
    },
      options);
    }




export const getRemoveCreatePurchaseOrderByQuotationMutationKey = () => ['removeCreatePurchaseOrderByQuotation'] as const;

export const getRemoveCreatePurchaseOrderByQuotationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeCreatePurchaseOrderByQuotation>>, TError,RemoveCreatePurchaseOrderByQuotationMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof removeCreatePurchaseOrderByQuotation>>, TError,RemoveCreatePurchaseOrderByQuotationMutationVariables, TContext> => {

const mutationKey = getRemoveCreatePurchaseOrderByQuotationMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeCreatePurchaseOrderByQuotation>>, RemoveCreatePurchaseOrderByQuotationMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  removeCreatePurchaseOrderByQuotation(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemoveCreatePurchaseOrderByQuotationMutationResult = NonNullable<Awaited<ReturnType<typeof removeCreatePurchaseOrderByQuotation>>>

    export type RemoveCreatePurchaseOrderByQuotationMutationError = ErrorType<unknown>
    export type RemoveCreatePurchaseOrderByQuotationMutationVariables = {id: number}

    /**
 * @summary Remove create purchase order by quotation
 */
export const useRemoveCreatePurchaseOrderByQuotation = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeCreatePurchaseOrderByQuotation>>, TError,RemoveCreatePurchaseOrderByQuotationMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof removeCreatePurchaseOrderByQuotation>>,
        TError,
        RemoveCreatePurchaseOrderByQuotationMutationVariables,
        TContext
      > => {
      return useMutation(getRemoveCreatePurchaseOrderByQuotationMutationOptions(options), queryClient);
    }
    /**
 * @summary List internal and vendor conversations for a quotation
 */
export const listQuotationChats = (
    id: number,
    params?: ListQuotationChatsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<EntitiesQuotationMemberChatListResponse>(
      {url: `/api/v3/quotations/${id}/chats`, method: 'GET',
        params, signal
    },
      options);
    }




export const getListQuotationChatsInfiniteQueryKey = (id: number,
    params?: ListQuotationChatsParams,) => {
    return [
    'infinite', `/api/v3/quotations/${id}/chats`, ...(params ? [params] : [])
    ] as const;
    }

export const getListQuotationChatsQueryKey = (id: number,
    params?: ListQuotationChatsParams,) => {
    return [
    `/api/v3/quotations/${id}/chats`, ...(params ? [params] : [])
    ] as const;
    }


export const useListQuotationChatsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof listQuotationChats>>>, TError = ErrorType<unknown>>(id: number,
    params?: ListQuotationChatsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listQuotationChats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListQuotationChatsInfiniteQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listQuotationChats>>> = ({ signal }) => listQuotationChats(id,params, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions});

   return  customOptions as UseInfiniteQueryOptions<Awaited<ReturnType<typeof listQuotationChats>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListQuotationChatsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof listQuotationChats>>>
export type ListQuotationChatsInfiniteQueryError = ErrorType<unknown>


export function useListQuotationChatsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listQuotationChats>>>, TError = ErrorType<unknown>>(
 id: number,
    params: undefined |  ListQuotationChatsParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listQuotationChats>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listQuotationChats>>,
          TError,
          Awaited<ReturnType<typeof listQuotationChats>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListQuotationChatsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listQuotationChats>>>, TError = ErrorType<unknown>>(
 id: number,
    params?: ListQuotationChatsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listQuotationChats>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listQuotationChats>>,
          TError,
          Awaited<ReturnType<typeof listQuotationChats>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListQuotationChatsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listQuotationChats>>>, TError = ErrorType<unknown>>(
 id: number,
    params?: ListQuotationChatsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listQuotationChats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List internal and vendor conversations for a quotation
 */

export function useListQuotationChatsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listQuotationChats>>>, TError = ErrorType<unknown>>(
 id: number,
    params?: ListQuotationChatsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listQuotationChats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListQuotationChatsInfiniteQueryOptions(id,params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List internal and vendor conversations for a quotation
 */
export const prefetchListQuotationChatsInfiniteQuery = async <TData = Awaited<ReturnType<typeof listQuotationChats>>, TError = ErrorType<unknown>>(
 queryClient: QueryClient, id: number,
    params?: ListQuotationChatsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listQuotationChats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = useListQuotationChatsInfiniteQueryOptions(id,params,options)

  await queryClient.infiniteQuery(queryOptions).catch(() => {});

  return queryClient;
}

/**
 * @summary Invalidates the {@link useListQuotationChatsInfinite} query
 */
export const invalidateListQuotationChatsInfinite = async (
 queryClient: QueryClient, id: number,
    params?: ListQuotationChatsParams, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: customQueryOptions({ queryKey: getListQuotationChatsInfiniteQueryKey(id,params) }).queryKey }, options);

  return queryClient;
}




export const useListQuotationChatsQueryOptions = <TData = Awaited<ReturnType<typeof listQuotationChats>>, TError = ErrorType<unknown>>(id: number,
    params?: ListQuotationChatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listQuotationChats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListQuotationChatsQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listQuotationChats>>> = ({ signal }) => listQuotationChats(id,params, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof listQuotationChats>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListQuotationChatsQueryResult = NonNullable<Awaited<ReturnType<typeof listQuotationChats>>>
export type ListQuotationChatsQueryError = ErrorType<unknown>


export function useListQuotationChats<TData = Awaited<ReturnType<typeof listQuotationChats>>, TError = ErrorType<unknown>>(
 id: number,
    params: undefined |  ListQuotationChatsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listQuotationChats>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listQuotationChats>>,
          TError,
          Awaited<ReturnType<typeof listQuotationChats>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListQuotationChats<TData = Awaited<ReturnType<typeof listQuotationChats>>, TError = ErrorType<unknown>>(
 id: number,
    params?: ListQuotationChatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listQuotationChats>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listQuotationChats>>,
          TError,
          Awaited<ReturnType<typeof listQuotationChats>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListQuotationChats<TData = Awaited<ReturnType<typeof listQuotationChats>>, TError = ErrorType<unknown>>(
 id: number,
    params?: ListQuotationChatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listQuotationChats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List internal and vendor conversations for a quotation
 */

export function useListQuotationChats<TData = Awaited<ReturnType<typeof listQuotationChats>>, TError = ErrorType<unknown>>(
 id: number,
    params?: ListQuotationChatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listQuotationChats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListQuotationChatsQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List internal and vendor conversations for a quotation
 */
export const prefetchListQuotationChatsQuery = async <TData = Awaited<ReturnType<typeof listQuotationChats>>, TError = ErrorType<unknown>>(
 queryClient: QueryClient, id: number,
    params?: ListQuotationChatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listQuotationChats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = useListQuotationChatsQueryOptions(id,params,options)

  await queryClient.query(queryOptions).catch(() => {});

  return queryClient;
}

/**
 * @summary Invalidates the {@link useListQuotationChats} query
 */
export const invalidateListQuotationChats = async (
 queryClient: QueryClient, id: number,
    params?: ListQuotationChatsParams, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: customQueryOptions({ queryKey: getListQuotationChatsQueryKey(id,params) }).queryKey }, options);

  return queryClient;
}




export const useListQuotationChatsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listQuotationChats>>, TError = ErrorType<unknown>>(id: number,
    params?: ListQuotationChatsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listQuotationChats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListQuotationChatsQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listQuotationChats>>> = ({ signal }) => listQuotationChats(id,params, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, ...queryOptions});

   return  customOptions as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listQuotationChats>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListQuotationChatsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listQuotationChats>>>
export type ListQuotationChatsSuspenseQueryError = ErrorType<unknown>


export function useListQuotationChatsSuspense<TData = Awaited<ReturnType<typeof listQuotationChats>>, TError = ErrorType<unknown>>(
 id: number,
    params: undefined |  ListQuotationChatsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listQuotationChats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListQuotationChatsSuspense<TData = Awaited<ReturnType<typeof listQuotationChats>>, TError = ErrorType<unknown>>(
 id: number,
    params?: ListQuotationChatsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listQuotationChats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListQuotationChatsSuspense<TData = Awaited<ReturnType<typeof listQuotationChats>>, TError = ErrorType<unknown>>(
 id: number,
    params?: ListQuotationChatsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listQuotationChats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List internal and vendor conversations for a quotation
 */

export function useListQuotationChatsSuspense<TData = Awaited<ReturnType<typeof listQuotationChats>>, TError = ErrorType<unknown>>(
 id: number,
    params?: ListQuotationChatsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listQuotationChats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListQuotationChatsSuspenseQueryOptions(id,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useListQuotationChatsSuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof listQuotationChats>>>, TError = ErrorType<unknown>>(id: number,
    params?: ListQuotationChatsParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof listQuotationChats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListQuotationChatsInfiniteQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listQuotationChats>>> = ({ signal }) => listQuotationChats(id,params, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, ...queryOptions});

   return  customOptions as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof listQuotationChats>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListQuotationChatsSuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof listQuotationChats>>>
export type ListQuotationChatsSuspenseInfiniteQueryError = ErrorType<unknown>


export function useListQuotationChatsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listQuotationChats>>>, TError = ErrorType<unknown>>(
 id: number,
    params: undefined |  ListQuotationChatsParams, options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof listQuotationChats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListQuotationChatsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listQuotationChats>>>, TError = ErrorType<unknown>>(
 id: number,
    params?: ListQuotationChatsParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof listQuotationChats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListQuotationChatsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listQuotationChats>>>, TError = ErrorType<unknown>>(
 id: number,
    params?: ListQuotationChatsParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof listQuotationChats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List internal and vendor conversations for a quotation
 */

export function useListQuotationChatsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listQuotationChats>>>, TError = ErrorType<unknown>>(
 id: number,
    params?: ListQuotationChatsParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof listQuotationChats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListQuotationChatsSuspenseInfiniteQueryOptions(id,params,options)

  const query = useSuspenseInfiniteQuery(queryOptions, queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Ensure quotation conversations exist and return their summaries
 */
export const ensureQuotationChats = (
    id: number,
    ensureQuotationChatsRequest?: EnsureQuotationChatsRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<EntitiesQuotationMemberChatListResponse>(
      {url: `/api/v3/quotations/${id}/chats/ensure`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: ensureQuotationChatsRequest, signal
    },
      options);
    }




export const getEnsureQuotationChatsMutationKey = () => ['ensureQuotationChats'] as const;

export const getEnsureQuotationChatsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ensureQuotationChats>>, TError,EnsureQuotationChatsMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof ensureQuotationChats>>, TError,EnsureQuotationChatsMutationVariables, TContext> => {

const mutationKey = getEnsureQuotationChatsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof ensureQuotationChats>>, EnsureQuotationChatsMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  ensureQuotationChats(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EnsureQuotationChatsMutationResult = NonNullable<Awaited<ReturnType<typeof ensureQuotationChats>>>
    export type EnsureQuotationChatsMutationBody = EnsureQuotationChatsRequest | undefined
    export type EnsureQuotationChatsMutationError = ErrorType<unknown>
    export type EnsureQuotationChatsMutationVariables = {id: number;data?: EnsureQuotationChatsRequest}

    /**
 * @summary Ensure quotation conversations exist and return their summaries
 */
export const useEnsureQuotationChats = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ensureQuotationChats>>, TError,EnsureQuotationChatsMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof ensureQuotationChats>>,
        TError,
        EnsureQuotationChatsMutationVariables,
        TContext
      > => {
      return useMutation(getEnsureQuotationChatsMutationOptions(options), queryClient);
    }
    /**
 * @summary List the conversation for a quotation negotiation
 */
export const listQuotationNegotiationChats = (
    id: number,
    negotiationId: number,
    params?: ListQuotationNegotiationChatsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<EntitiesQuotationMemberChatListResponse>(
      {url: `/api/v3/quotations/${id}/negotiations/${negotiationId}/chats`, method: 'GET',
        params, signal
    },
      options);
    }




export const getListQuotationNegotiationChatsInfiniteQueryKey = (id: number,
    negotiationId: number,
    params?: ListQuotationNegotiationChatsParams,) => {
    return [
    'infinite', `/api/v3/quotations/${id}/negotiations/${negotiationId}/chats`, ...(params ? [params] : [])
    ] as const;
    }

export const getListQuotationNegotiationChatsQueryKey = (id: number,
    negotiationId: number,
    params?: ListQuotationNegotiationChatsParams,) => {
    return [
    `/api/v3/quotations/${id}/negotiations/${negotiationId}/chats`, ...(params ? [params] : [])
    ] as const;
    }


export const useListQuotationNegotiationChatsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof listQuotationNegotiationChats>>>, TError = ErrorType<unknown>>(id: number,
    negotiationId: number,
    params?: ListQuotationNegotiationChatsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listQuotationNegotiationChats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListQuotationNegotiationChatsInfiniteQueryKey(id,negotiationId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listQuotationNegotiationChats>>> = ({ signal }) => listQuotationNegotiationChats(id,negotiationId,params, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, enabled: id !== null && id !== undefined && negotiationId !== null && negotiationId !== undefined, ...queryOptions});

   return  customOptions as UseInfiniteQueryOptions<Awaited<ReturnType<typeof listQuotationNegotiationChats>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListQuotationNegotiationChatsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof listQuotationNegotiationChats>>>
export type ListQuotationNegotiationChatsInfiniteQueryError = ErrorType<unknown>


export function useListQuotationNegotiationChatsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listQuotationNegotiationChats>>>, TError = ErrorType<unknown>>(
 id: number,
    negotiationId: number,
    params: undefined |  ListQuotationNegotiationChatsParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listQuotationNegotiationChats>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listQuotationNegotiationChats>>,
          TError,
          Awaited<ReturnType<typeof listQuotationNegotiationChats>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListQuotationNegotiationChatsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listQuotationNegotiationChats>>>, TError = ErrorType<unknown>>(
 id: number,
    negotiationId: number,
    params?: ListQuotationNegotiationChatsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listQuotationNegotiationChats>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listQuotationNegotiationChats>>,
          TError,
          Awaited<ReturnType<typeof listQuotationNegotiationChats>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListQuotationNegotiationChatsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listQuotationNegotiationChats>>>, TError = ErrorType<unknown>>(
 id: number,
    negotiationId: number,
    params?: ListQuotationNegotiationChatsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listQuotationNegotiationChats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List the conversation for a quotation negotiation
 */

export function useListQuotationNegotiationChatsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listQuotationNegotiationChats>>>, TError = ErrorType<unknown>>(
 id: number,
    negotiationId: number,
    params?: ListQuotationNegotiationChatsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listQuotationNegotiationChats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListQuotationNegotiationChatsInfiniteQueryOptions(id,negotiationId,params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List the conversation for a quotation negotiation
 */
export const prefetchListQuotationNegotiationChatsInfiniteQuery = async <TData = Awaited<ReturnType<typeof listQuotationNegotiationChats>>, TError = ErrorType<unknown>>(
 queryClient: QueryClient, id: number,
    negotiationId: number,
    params?: ListQuotationNegotiationChatsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listQuotationNegotiationChats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = useListQuotationNegotiationChatsInfiniteQueryOptions(id,negotiationId,params,options)

  await queryClient.infiniteQuery(queryOptions).catch(() => {});

  return queryClient;
}

/**
 * @summary Invalidates the {@link useListQuotationNegotiationChatsInfinite} query
 */
export const invalidateListQuotationNegotiationChatsInfinite = async (
 queryClient: QueryClient, id: number,
    negotiationId: number,
    params?: ListQuotationNegotiationChatsParams, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: customQueryOptions({ queryKey: getListQuotationNegotiationChatsInfiniteQueryKey(id,negotiationId,params) }).queryKey }, options);

  return queryClient;
}




export const useListQuotationNegotiationChatsQueryOptions = <TData = Awaited<ReturnType<typeof listQuotationNegotiationChats>>, TError = ErrorType<unknown>>(id: number,
    negotiationId: number,
    params?: ListQuotationNegotiationChatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listQuotationNegotiationChats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListQuotationNegotiationChatsQueryKey(id,negotiationId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listQuotationNegotiationChats>>> = ({ signal }) => listQuotationNegotiationChats(id,negotiationId,params, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, enabled: id !== null && id !== undefined && negotiationId !== null && negotiationId !== undefined, ...queryOptions});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof listQuotationNegotiationChats>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListQuotationNegotiationChatsQueryResult = NonNullable<Awaited<ReturnType<typeof listQuotationNegotiationChats>>>
export type ListQuotationNegotiationChatsQueryError = ErrorType<unknown>


export function useListQuotationNegotiationChats<TData = Awaited<ReturnType<typeof listQuotationNegotiationChats>>, TError = ErrorType<unknown>>(
 id: number,
    negotiationId: number,
    params: undefined |  ListQuotationNegotiationChatsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listQuotationNegotiationChats>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listQuotationNegotiationChats>>,
          TError,
          Awaited<ReturnType<typeof listQuotationNegotiationChats>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListQuotationNegotiationChats<TData = Awaited<ReturnType<typeof listQuotationNegotiationChats>>, TError = ErrorType<unknown>>(
 id: number,
    negotiationId: number,
    params?: ListQuotationNegotiationChatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listQuotationNegotiationChats>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listQuotationNegotiationChats>>,
          TError,
          Awaited<ReturnType<typeof listQuotationNegotiationChats>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListQuotationNegotiationChats<TData = Awaited<ReturnType<typeof listQuotationNegotiationChats>>, TError = ErrorType<unknown>>(
 id: number,
    negotiationId: number,
    params?: ListQuotationNegotiationChatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listQuotationNegotiationChats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List the conversation for a quotation negotiation
 */

export function useListQuotationNegotiationChats<TData = Awaited<ReturnType<typeof listQuotationNegotiationChats>>, TError = ErrorType<unknown>>(
 id: number,
    negotiationId: number,
    params?: ListQuotationNegotiationChatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listQuotationNegotiationChats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListQuotationNegotiationChatsQueryOptions(id,negotiationId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List the conversation for a quotation negotiation
 */
export const prefetchListQuotationNegotiationChatsQuery = async <TData = Awaited<ReturnType<typeof listQuotationNegotiationChats>>, TError = ErrorType<unknown>>(
 queryClient: QueryClient, id: number,
    negotiationId: number,
    params?: ListQuotationNegotiationChatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listQuotationNegotiationChats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = useListQuotationNegotiationChatsQueryOptions(id,negotiationId,params,options)

  await queryClient.query(queryOptions).catch(() => {});

  return queryClient;
}

/**
 * @summary Invalidates the {@link useListQuotationNegotiationChats} query
 */
export const invalidateListQuotationNegotiationChats = async (
 queryClient: QueryClient, id: number,
    negotiationId: number,
    params?: ListQuotationNegotiationChatsParams, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: customQueryOptions({ queryKey: getListQuotationNegotiationChatsQueryKey(id,negotiationId,params) }).queryKey }, options);

  return queryClient;
}




export const useListQuotationNegotiationChatsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listQuotationNegotiationChats>>, TError = ErrorType<unknown>>(id: number,
    negotiationId: number,
    params?: ListQuotationNegotiationChatsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listQuotationNegotiationChats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListQuotationNegotiationChatsQueryKey(id,negotiationId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listQuotationNegotiationChats>>> = ({ signal }) => listQuotationNegotiationChats(id,negotiationId,params, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, ...queryOptions});

   return  customOptions as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listQuotationNegotiationChats>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListQuotationNegotiationChatsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listQuotationNegotiationChats>>>
export type ListQuotationNegotiationChatsSuspenseQueryError = ErrorType<unknown>


export function useListQuotationNegotiationChatsSuspense<TData = Awaited<ReturnType<typeof listQuotationNegotiationChats>>, TError = ErrorType<unknown>>(
 id: number,
    negotiationId: number,
    params: undefined |  ListQuotationNegotiationChatsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listQuotationNegotiationChats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListQuotationNegotiationChatsSuspense<TData = Awaited<ReturnType<typeof listQuotationNegotiationChats>>, TError = ErrorType<unknown>>(
 id: number,
    negotiationId: number,
    params?: ListQuotationNegotiationChatsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listQuotationNegotiationChats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListQuotationNegotiationChatsSuspense<TData = Awaited<ReturnType<typeof listQuotationNegotiationChats>>, TError = ErrorType<unknown>>(
 id: number,
    negotiationId: number,
    params?: ListQuotationNegotiationChatsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listQuotationNegotiationChats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List the conversation for a quotation negotiation
 */

export function useListQuotationNegotiationChatsSuspense<TData = Awaited<ReturnType<typeof listQuotationNegotiationChats>>, TError = ErrorType<unknown>>(
 id: number,
    negotiationId: number,
    params?: ListQuotationNegotiationChatsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listQuotationNegotiationChats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListQuotationNegotiationChatsSuspenseQueryOptions(id,negotiationId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useListQuotationNegotiationChatsSuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof listQuotationNegotiationChats>>>, TError = ErrorType<unknown>>(id: number,
    negotiationId: number,
    params?: ListQuotationNegotiationChatsParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof listQuotationNegotiationChats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListQuotationNegotiationChatsInfiniteQueryKey(id,negotiationId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listQuotationNegotiationChats>>> = ({ signal }) => listQuotationNegotiationChats(id,negotiationId,params, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, ...queryOptions});

   return  customOptions as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof listQuotationNegotiationChats>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListQuotationNegotiationChatsSuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof listQuotationNegotiationChats>>>
export type ListQuotationNegotiationChatsSuspenseInfiniteQueryError = ErrorType<unknown>


export function useListQuotationNegotiationChatsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listQuotationNegotiationChats>>>, TError = ErrorType<unknown>>(
 id: number,
    negotiationId: number,
    params: undefined |  ListQuotationNegotiationChatsParams, options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof listQuotationNegotiationChats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListQuotationNegotiationChatsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listQuotationNegotiationChats>>>, TError = ErrorType<unknown>>(
 id: number,
    negotiationId: number,
    params?: ListQuotationNegotiationChatsParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof listQuotationNegotiationChats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListQuotationNegotiationChatsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listQuotationNegotiationChats>>>, TError = ErrorType<unknown>>(
 id: number,
    negotiationId: number,
    params?: ListQuotationNegotiationChatsParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof listQuotationNegotiationChats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List the conversation for a quotation negotiation
 */

export function useListQuotationNegotiationChatsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listQuotationNegotiationChats>>>, TError = ErrorType<unknown>>(
 id: number,
    negotiationId: number,
    params?: ListQuotationNegotiationChatsParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof listQuotationNegotiationChats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListQuotationNegotiationChatsSuspenseInfiniteQueryOptions(id,negotiationId,params,options)

  const query = useSuspenseInfiniteQuery(queryOptions, queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Ensure a quotation negotiation conversation exists
 */
export const ensureQuotationNegotiationChat = (
    id: number,
    negotiationId: number,
    ensureQuotationNegotiationChatRequest?: EnsureQuotationNegotiationChatRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<EntitiesQuotationMemberChatListResponse>(
      {url: `/api/v3/quotations/${id}/negotiations/${negotiationId}/chats/ensure`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: ensureQuotationNegotiationChatRequest, signal
    },
      options);
    }




export const getEnsureQuotationNegotiationChatMutationKey = () => ['ensureQuotationNegotiationChat'] as const;

export const getEnsureQuotationNegotiationChatMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ensureQuotationNegotiationChat>>, TError,EnsureQuotationNegotiationChatMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof ensureQuotationNegotiationChat>>, TError,EnsureQuotationNegotiationChatMutationVariables, TContext> => {

const mutationKey = getEnsureQuotationNegotiationChatMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof ensureQuotationNegotiationChat>>, EnsureQuotationNegotiationChatMutationVariables> = (props) => {
          const {id,negotiationId,data} = props ?? {};

          return  ensureQuotationNegotiationChat(id,negotiationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EnsureQuotationNegotiationChatMutationResult = NonNullable<Awaited<ReturnType<typeof ensureQuotationNegotiationChat>>>
    export type EnsureQuotationNegotiationChatMutationBody = EnsureQuotationNegotiationChatRequest | undefined
    export type EnsureQuotationNegotiationChatMutationError = ErrorType<unknown>
    export type EnsureQuotationNegotiationChatMutationVariables = {id: number;negotiationId: number;data?: EnsureQuotationNegotiationChatRequest}

    /**
 * @summary Ensure a quotation negotiation conversation exists
 */
export const useEnsureQuotationNegotiationChat = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ensureQuotationNegotiationChat>>, TError,EnsureQuotationNegotiationChatMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof ensureQuotationNegotiationChat>>,
        TError,
        EnsureQuotationNegotiationChatMutationVariables,
        TContext
      > => {
      return useMutation(getEnsureQuotationNegotiationChatMutationOptions(options), queryClient);
    }
    /**
 * @summary List assignable users for a quotation
 */
export const listQuotationAssignableUsers = (
    id: number,
    params?: ListQuotationAssignableUsersParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<EntitiesQuotationMemberAssignableUserListResponse>(
      {url: `/api/v3/quotations/${id}/assignable_users`, method: 'GET',
        params, signal
    },
      options);
    }




export const getListQuotationAssignableUsersInfiniteQueryKey = (id: number,
    params?: ListQuotationAssignableUsersParams,) => {
    return [
    'infinite', `/api/v3/quotations/${id}/assignable_users`, ...(params ? [params] : [])
    ] as const;
    }

export const getListQuotationAssignableUsersQueryKey = (id: number,
    params?: ListQuotationAssignableUsersParams,) => {
    return [
    `/api/v3/quotations/${id}/assignable_users`, ...(params ? [params] : [])
    ] as const;
    }


export const useListQuotationAssignableUsersInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof listQuotationAssignableUsers>>>, TError = ErrorType<unknown>>(id: number,
    params?: ListQuotationAssignableUsersParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listQuotationAssignableUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListQuotationAssignableUsersInfiniteQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listQuotationAssignableUsers>>> = ({ signal }) => listQuotationAssignableUsers(id,params, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions});

   return  customOptions as UseInfiniteQueryOptions<Awaited<ReturnType<typeof listQuotationAssignableUsers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListQuotationAssignableUsersInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof listQuotationAssignableUsers>>>
export type ListQuotationAssignableUsersInfiniteQueryError = ErrorType<unknown>


export function useListQuotationAssignableUsersInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listQuotationAssignableUsers>>>, TError = ErrorType<unknown>>(
 id: number,
    params: undefined |  ListQuotationAssignableUsersParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listQuotationAssignableUsers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listQuotationAssignableUsers>>,
          TError,
          Awaited<ReturnType<typeof listQuotationAssignableUsers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListQuotationAssignableUsersInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listQuotationAssignableUsers>>>, TError = ErrorType<unknown>>(
 id: number,
    params?: ListQuotationAssignableUsersParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listQuotationAssignableUsers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listQuotationAssignableUsers>>,
          TError,
          Awaited<ReturnType<typeof listQuotationAssignableUsers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListQuotationAssignableUsersInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listQuotationAssignableUsers>>>, TError = ErrorType<unknown>>(
 id: number,
    params?: ListQuotationAssignableUsersParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listQuotationAssignableUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List assignable users for a quotation
 */

export function useListQuotationAssignableUsersInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listQuotationAssignableUsers>>>, TError = ErrorType<unknown>>(
 id: number,
    params?: ListQuotationAssignableUsersParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listQuotationAssignableUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListQuotationAssignableUsersInfiniteQueryOptions(id,params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List assignable users for a quotation
 */
export const prefetchListQuotationAssignableUsersInfiniteQuery = async <TData = Awaited<ReturnType<typeof listQuotationAssignableUsers>>, TError = ErrorType<unknown>>(
 queryClient: QueryClient, id: number,
    params?: ListQuotationAssignableUsersParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listQuotationAssignableUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = useListQuotationAssignableUsersInfiniteQueryOptions(id,params,options)

  await queryClient.infiniteQuery(queryOptions).catch(() => {});

  return queryClient;
}

/**
 * @summary Invalidates the {@link useListQuotationAssignableUsersInfinite} query
 */
export const invalidateListQuotationAssignableUsersInfinite = async (
 queryClient: QueryClient, id: number,
    params?: ListQuotationAssignableUsersParams, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: customQueryOptions({ queryKey: getListQuotationAssignableUsersInfiniteQueryKey(id,params) }).queryKey }, options);

  return queryClient;
}




export const useListQuotationAssignableUsersQueryOptions = <TData = Awaited<ReturnType<typeof listQuotationAssignableUsers>>, TError = ErrorType<unknown>>(id: number,
    params?: ListQuotationAssignableUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listQuotationAssignableUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListQuotationAssignableUsersQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listQuotationAssignableUsers>>> = ({ signal }) => listQuotationAssignableUsers(id,params, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof listQuotationAssignableUsers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListQuotationAssignableUsersQueryResult = NonNullable<Awaited<ReturnType<typeof listQuotationAssignableUsers>>>
export type ListQuotationAssignableUsersQueryError = ErrorType<unknown>


export function useListQuotationAssignableUsers<TData = Awaited<ReturnType<typeof listQuotationAssignableUsers>>, TError = ErrorType<unknown>>(
 id: number,
    params: undefined |  ListQuotationAssignableUsersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listQuotationAssignableUsers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listQuotationAssignableUsers>>,
          TError,
          Awaited<ReturnType<typeof listQuotationAssignableUsers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListQuotationAssignableUsers<TData = Awaited<ReturnType<typeof listQuotationAssignableUsers>>, TError = ErrorType<unknown>>(
 id: number,
    params?: ListQuotationAssignableUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listQuotationAssignableUsers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listQuotationAssignableUsers>>,
          TError,
          Awaited<ReturnType<typeof listQuotationAssignableUsers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListQuotationAssignableUsers<TData = Awaited<ReturnType<typeof listQuotationAssignableUsers>>, TError = ErrorType<unknown>>(
 id: number,
    params?: ListQuotationAssignableUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listQuotationAssignableUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List assignable users for a quotation
 */

export function useListQuotationAssignableUsers<TData = Awaited<ReturnType<typeof listQuotationAssignableUsers>>, TError = ErrorType<unknown>>(
 id: number,
    params?: ListQuotationAssignableUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listQuotationAssignableUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListQuotationAssignableUsersQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List assignable users for a quotation
 */
export const prefetchListQuotationAssignableUsersQuery = async <TData = Awaited<ReturnType<typeof listQuotationAssignableUsers>>, TError = ErrorType<unknown>>(
 queryClient: QueryClient, id: number,
    params?: ListQuotationAssignableUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listQuotationAssignableUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = useListQuotationAssignableUsersQueryOptions(id,params,options)

  await queryClient.query(queryOptions).catch(() => {});

  return queryClient;
}

/**
 * @summary Invalidates the {@link useListQuotationAssignableUsers} query
 */
export const invalidateListQuotationAssignableUsers = async (
 queryClient: QueryClient, id: number,
    params?: ListQuotationAssignableUsersParams, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: customQueryOptions({ queryKey: getListQuotationAssignableUsersQueryKey(id,params) }).queryKey }, options);

  return queryClient;
}




export const useListQuotationAssignableUsersSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listQuotationAssignableUsers>>, TError = ErrorType<unknown>>(id: number,
    params?: ListQuotationAssignableUsersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listQuotationAssignableUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListQuotationAssignableUsersQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listQuotationAssignableUsers>>> = ({ signal }) => listQuotationAssignableUsers(id,params, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, ...queryOptions});

   return  customOptions as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listQuotationAssignableUsers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListQuotationAssignableUsersSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listQuotationAssignableUsers>>>
export type ListQuotationAssignableUsersSuspenseQueryError = ErrorType<unknown>


export function useListQuotationAssignableUsersSuspense<TData = Awaited<ReturnType<typeof listQuotationAssignableUsers>>, TError = ErrorType<unknown>>(
 id: number,
    params: undefined |  ListQuotationAssignableUsersParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listQuotationAssignableUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListQuotationAssignableUsersSuspense<TData = Awaited<ReturnType<typeof listQuotationAssignableUsers>>, TError = ErrorType<unknown>>(
 id: number,
    params?: ListQuotationAssignableUsersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listQuotationAssignableUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListQuotationAssignableUsersSuspense<TData = Awaited<ReturnType<typeof listQuotationAssignableUsers>>, TError = ErrorType<unknown>>(
 id: number,
    params?: ListQuotationAssignableUsersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listQuotationAssignableUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List assignable users for a quotation
 */

export function useListQuotationAssignableUsersSuspense<TData = Awaited<ReturnType<typeof listQuotationAssignableUsers>>, TError = ErrorType<unknown>>(
 id: number,
    params?: ListQuotationAssignableUsersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listQuotationAssignableUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListQuotationAssignableUsersSuspenseQueryOptions(id,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useListQuotationAssignableUsersSuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof listQuotationAssignableUsers>>>, TError = ErrorType<unknown>>(id: number,
    params?: ListQuotationAssignableUsersParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof listQuotationAssignableUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListQuotationAssignableUsersInfiniteQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listQuotationAssignableUsers>>> = ({ signal }) => listQuotationAssignableUsers(id,params, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, ...queryOptions});

   return  customOptions as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof listQuotationAssignableUsers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListQuotationAssignableUsersSuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof listQuotationAssignableUsers>>>
export type ListQuotationAssignableUsersSuspenseInfiniteQueryError = ErrorType<unknown>


export function useListQuotationAssignableUsersSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listQuotationAssignableUsers>>>, TError = ErrorType<unknown>>(
 id: number,
    params: undefined |  ListQuotationAssignableUsersParams, options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof listQuotationAssignableUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListQuotationAssignableUsersSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listQuotationAssignableUsers>>>, TError = ErrorType<unknown>>(
 id: number,
    params?: ListQuotationAssignableUsersParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof listQuotationAssignableUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListQuotationAssignableUsersSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listQuotationAssignableUsers>>>, TError = ErrorType<unknown>>(
 id: number,
    params?: ListQuotationAssignableUsersParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof listQuotationAssignableUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List assignable users for a quotation
 */

export function useListQuotationAssignableUsersSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listQuotationAssignableUsers>>>, TError = ErrorType<unknown>>(
 id: number,
    params?: ListQuotationAssignableUsersParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof listQuotationAssignableUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListQuotationAssignableUsersSuspenseInfiniteQueryOptions(id,params,options)

  const query = useSuspenseInfiniteQuery(queryOptions, queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary List quotation doubts
 */
export const listQuotationDoubts = (
    id: number,
    params?: ListQuotationDoubtsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<EntitiesQuotationMemberDoubtsListResponse>(
      {url: `/api/v3/quotations/${id}/doubts`, method: 'GET',
        params, signal
    },
      options);
    }




export const getListQuotationDoubtsInfiniteQueryKey = (id: number,
    params?: ListQuotationDoubtsParams,) => {
    return [
    'infinite', `/api/v3/quotations/${id}/doubts`, ...(params ? [params] : [])
    ] as const;
    }

export const getListQuotationDoubtsQueryKey = (id: number,
    params?: ListQuotationDoubtsParams,) => {
    return [
    `/api/v3/quotations/${id}/doubts`, ...(params ? [params] : [])
    ] as const;
    }


export const useListQuotationDoubtsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof listQuotationDoubts>>>, TError = ErrorType<unknown>>(id: number,
    params?: ListQuotationDoubtsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listQuotationDoubts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListQuotationDoubtsInfiniteQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listQuotationDoubts>>> = ({ signal }) => listQuotationDoubts(id,params, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions});

   return  customOptions as UseInfiniteQueryOptions<Awaited<ReturnType<typeof listQuotationDoubts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListQuotationDoubtsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof listQuotationDoubts>>>
export type ListQuotationDoubtsInfiniteQueryError = ErrorType<unknown>


export function useListQuotationDoubtsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listQuotationDoubts>>>, TError = ErrorType<unknown>>(
 id: number,
    params: undefined |  ListQuotationDoubtsParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listQuotationDoubts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listQuotationDoubts>>,
          TError,
          Awaited<ReturnType<typeof listQuotationDoubts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListQuotationDoubtsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listQuotationDoubts>>>, TError = ErrorType<unknown>>(
 id: number,
    params?: ListQuotationDoubtsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listQuotationDoubts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listQuotationDoubts>>,
          TError,
          Awaited<ReturnType<typeof listQuotationDoubts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListQuotationDoubtsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listQuotationDoubts>>>, TError = ErrorType<unknown>>(
 id: number,
    params?: ListQuotationDoubtsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listQuotationDoubts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List quotation doubts
 */

export function useListQuotationDoubtsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listQuotationDoubts>>>, TError = ErrorType<unknown>>(
 id: number,
    params?: ListQuotationDoubtsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listQuotationDoubts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListQuotationDoubtsInfiniteQueryOptions(id,params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List quotation doubts
 */
export const prefetchListQuotationDoubtsInfiniteQuery = async <TData = Awaited<ReturnType<typeof listQuotationDoubts>>, TError = ErrorType<unknown>>(
 queryClient: QueryClient, id: number,
    params?: ListQuotationDoubtsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listQuotationDoubts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = useListQuotationDoubtsInfiniteQueryOptions(id,params,options)

  await queryClient.infiniteQuery(queryOptions).catch(() => {});

  return queryClient;
}

/**
 * @summary Invalidates the {@link useListQuotationDoubtsInfinite} query
 */
export const invalidateListQuotationDoubtsInfinite = async (
 queryClient: QueryClient, id: number,
    params?: ListQuotationDoubtsParams, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: customQueryOptions({ queryKey: getListQuotationDoubtsInfiniteQueryKey(id,params) }).queryKey }, options);

  return queryClient;
}




export const useListQuotationDoubtsQueryOptions = <TData = Awaited<ReturnType<typeof listQuotationDoubts>>, TError = ErrorType<unknown>>(id: number,
    params?: ListQuotationDoubtsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listQuotationDoubts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListQuotationDoubtsQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listQuotationDoubts>>> = ({ signal }) => listQuotationDoubts(id,params, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof listQuotationDoubts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListQuotationDoubtsQueryResult = NonNullable<Awaited<ReturnType<typeof listQuotationDoubts>>>
export type ListQuotationDoubtsQueryError = ErrorType<unknown>


export function useListQuotationDoubts<TData = Awaited<ReturnType<typeof listQuotationDoubts>>, TError = ErrorType<unknown>>(
 id: number,
    params: undefined |  ListQuotationDoubtsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listQuotationDoubts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listQuotationDoubts>>,
          TError,
          Awaited<ReturnType<typeof listQuotationDoubts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListQuotationDoubts<TData = Awaited<ReturnType<typeof listQuotationDoubts>>, TError = ErrorType<unknown>>(
 id: number,
    params?: ListQuotationDoubtsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listQuotationDoubts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listQuotationDoubts>>,
          TError,
          Awaited<ReturnType<typeof listQuotationDoubts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListQuotationDoubts<TData = Awaited<ReturnType<typeof listQuotationDoubts>>, TError = ErrorType<unknown>>(
 id: number,
    params?: ListQuotationDoubtsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listQuotationDoubts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List quotation doubts
 */

export function useListQuotationDoubts<TData = Awaited<ReturnType<typeof listQuotationDoubts>>, TError = ErrorType<unknown>>(
 id: number,
    params?: ListQuotationDoubtsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listQuotationDoubts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListQuotationDoubtsQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List quotation doubts
 */
export const prefetchListQuotationDoubtsQuery = async <TData = Awaited<ReturnType<typeof listQuotationDoubts>>, TError = ErrorType<unknown>>(
 queryClient: QueryClient, id: number,
    params?: ListQuotationDoubtsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listQuotationDoubts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = useListQuotationDoubtsQueryOptions(id,params,options)

  await queryClient.query(queryOptions).catch(() => {});

  return queryClient;
}

/**
 * @summary Invalidates the {@link useListQuotationDoubts} query
 */
export const invalidateListQuotationDoubts = async (
 queryClient: QueryClient, id: number,
    params?: ListQuotationDoubtsParams, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: customQueryOptions({ queryKey: getListQuotationDoubtsQueryKey(id,params) }).queryKey }, options);

  return queryClient;
}




export const useListQuotationDoubtsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listQuotationDoubts>>, TError = ErrorType<unknown>>(id: number,
    params?: ListQuotationDoubtsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listQuotationDoubts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListQuotationDoubtsQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listQuotationDoubts>>> = ({ signal }) => listQuotationDoubts(id,params, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, ...queryOptions});

   return  customOptions as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listQuotationDoubts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListQuotationDoubtsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listQuotationDoubts>>>
export type ListQuotationDoubtsSuspenseQueryError = ErrorType<unknown>


export function useListQuotationDoubtsSuspense<TData = Awaited<ReturnType<typeof listQuotationDoubts>>, TError = ErrorType<unknown>>(
 id: number,
    params: undefined |  ListQuotationDoubtsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listQuotationDoubts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListQuotationDoubtsSuspense<TData = Awaited<ReturnType<typeof listQuotationDoubts>>, TError = ErrorType<unknown>>(
 id: number,
    params?: ListQuotationDoubtsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listQuotationDoubts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListQuotationDoubtsSuspense<TData = Awaited<ReturnType<typeof listQuotationDoubts>>, TError = ErrorType<unknown>>(
 id: number,
    params?: ListQuotationDoubtsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listQuotationDoubts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List quotation doubts
 */

export function useListQuotationDoubtsSuspense<TData = Awaited<ReturnType<typeof listQuotationDoubts>>, TError = ErrorType<unknown>>(
 id: number,
    params?: ListQuotationDoubtsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listQuotationDoubts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListQuotationDoubtsSuspenseQueryOptions(id,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useListQuotationDoubtsSuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof listQuotationDoubts>>>, TError = ErrorType<unknown>>(id: number,
    params?: ListQuotationDoubtsParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof listQuotationDoubts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListQuotationDoubtsInfiniteQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listQuotationDoubts>>> = ({ signal }) => listQuotationDoubts(id,params, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, ...queryOptions});

   return  customOptions as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof listQuotationDoubts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListQuotationDoubtsSuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof listQuotationDoubts>>>
export type ListQuotationDoubtsSuspenseInfiniteQueryError = ErrorType<unknown>


export function useListQuotationDoubtsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listQuotationDoubts>>>, TError = ErrorType<unknown>>(
 id: number,
    params: undefined |  ListQuotationDoubtsParams, options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof listQuotationDoubts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListQuotationDoubtsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listQuotationDoubts>>>, TError = ErrorType<unknown>>(
 id: number,
    params?: ListQuotationDoubtsParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof listQuotationDoubts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListQuotationDoubtsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listQuotationDoubts>>>, TError = ErrorType<unknown>>(
 id: number,
    params?: ListQuotationDoubtsParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof listQuotationDoubts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List quotation doubts
 */

export function useListQuotationDoubtsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listQuotationDoubts>>>, TError = ErrorType<unknown>>(
 id: number,
    params?: ListQuotationDoubtsParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof listQuotationDoubts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListQuotationDoubtsSuspenseInfiniteQueryOptions(id,params,options)

  const query = useSuspenseInfiniteQuery(queryOptions, queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Get quotation offers tab payload
 */
export const getQuotationOffers = (
    quotationId: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<EntitiesQuotationMemberOffersCollectionMain>(
      {url: `/api/v3/quotations/${quotationId}/offers`, method: 'GET', signal
    },
      options);
    }




export const getGetQuotationOffersInfiniteQueryKey = (quotationId: number,) => {
    return [
    'infinite', `/api/v3/quotations/${quotationId}/offers`
    ] as const;
    }

export const getGetQuotationOffersQueryKey = (quotationId: number,) => {
    return [
    `/api/v3/quotations/${quotationId}/offers`
    ] as const;
    }


export const useGetQuotationOffersInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getQuotationOffers>>>, TError = ErrorType<unknown>>(quotationId: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getQuotationOffers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetQuotationOffersInfiniteQueryKey(quotationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getQuotationOffers>>> = ({ signal }) => getQuotationOffers(quotationId, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, enabled: quotationId !== null && quotationId !== undefined, ...queryOptions});

   return  customOptions as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getQuotationOffers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetQuotationOffersInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getQuotationOffers>>>
export type GetQuotationOffersInfiniteQueryError = ErrorType<unknown>


export function useGetQuotationOffersInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getQuotationOffers>>>, TError = ErrorType<unknown>>(
 quotationId: number, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getQuotationOffers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuotationOffers>>,
          TError,
          Awaited<ReturnType<typeof getQuotationOffers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetQuotationOffersInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getQuotationOffers>>>, TError = ErrorType<unknown>>(
 quotationId: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getQuotationOffers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuotationOffers>>,
          TError,
          Awaited<ReturnType<typeof getQuotationOffers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetQuotationOffersInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getQuotationOffers>>>, TError = ErrorType<unknown>>(
 quotationId: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getQuotationOffers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get quotation offers tab payload
 */

export function useGetQuotationOffersInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getQuotationOffers>>>, TError = ErrorType<unknown>>(
 quotationId: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getQuotationOffers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetQuotationOffersInfiniteQueryOptions(quotationId,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get quotation offers tab payload
 */
export const prefetchGetQuotationOffersInfiniteQuery = async <TData = Awaited<ReturnType<typeof getQuotationOffers>>, TError = ErrorType<unknown>>(
 queryClient: QueryClient, quotationId: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getQuotationOffers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = useGetQuotationOffersInfiniteQueryOptions(quotationId,options)

  await queryClient.infiniteQuery(queryOptions).catch(() => {});

  return queryClient;
}

/**
 * @summary Invalidates the {@link useGetQuotationOffersInfinite} query
 */
export const invalidateGetQuotationOffersInfinite = async (
 queryClient: QueryClient, quotationId: number, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: customQueryOptions({ queryKey: getGetQuotationOffersInfiniteQueryKey(quotationId) }).queryKey }, options);

  return queryClient;
}




export const useGetQuotationOffersQueryOptions = <TData = Awaited<ReturnType<typeof getQuotationOffers>>, TError = ErrorType<unknown>>(quotationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotationOffers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetQuotationOffersQueryKey(quotationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getQuotationOffers>>> = ({ signal }) => getQuotationOffers(quotationId, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, enabled: quotationId !== null && quotationId !== undefined, ...queryOptions});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof getQuotationOffers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetQuotationOffersQueryResult = NonNullable<Awaited<ReturnType<typeof getQuotationOffers>>>
export type GetQuotationOffersQueryError = ErrorType<unknown>


export function useGetQuotationOffers<TData = Awaited<ReturnType<typeof getQuotationOffers>>, TError = ErrorType<unknown>>(
 quotationId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotationOffers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuotationOffers>>,
          TError,
          Awaited<ReturnType<typeof getQuotationOffers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetQuotationOffers<TData = Awaited<ReturnType<typeof getQuotationOffers>>, TError = ErrorType<unknown>>(
 quotationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotationOffers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuotationOffers>>,
          TError,
          Awaited<ReturnType<typeof getQuotationOffers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetQuotationOffers<TData = Awaited<ReturnType<typeof getQuotationOffers>>, TError = ErrorType<unknown>>(
 quotationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotationOffers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get quotation offers tab payload
 */

export function useGetQuotationOffers<TData = Awaited<ReturnType<typeof getQuotationOffers>>, TError = ErrorType<unknown>>(
 quotationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotationOffers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetQuotationOffersQueryOptions(quotationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get quotation offers tab payload
 */
export const prefetchGetQuotationOffersQuery = async <TData = Awaited<ReturnType<typeof getQuotationOffers>>, TError = ErrorType<unknown>>(
 queryClient: QueryClient, quotationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotationOffers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = useGetQuotationOffersQueryOptions(quotationId,options)

  await queryClient.query(queryOptions).catch(() => {});

  return queryClient;
}

/**
 * @summary Invalidates the {@link useGetQuotationOffers} query
 */
export const invalidateGetQuotationOffers = async (
 queryClient: QueryClient, quotationId: number, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: customQueryOptions({ queryKey: getGetQuotationOffersQueryKey(quotationId) }).queryKey }, options);

  return queryClient;
}




export const useGetQuotationOffersSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getQuotationOffers>>, TError = ErrorType<unknown>>(quotationId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getQuotationOffers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetQuotationOffersQueryKey(quotationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getQuotationOffers>>> = ({ signal }) => getQuotationOffers(quotationId, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, ...queryOptions});

   return  customOptions as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getQuotationOffers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetQuotationOffersSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getQuotationOffers>>>
export type GetQuotationOffersSuspenseQueryError = ErrorType<unknown>


export function useGetQuotationOffersSuspense<TData = Awaited<ReturnType<typeof getQuotationOffers>>, TError = ErrorType<unknown>>(
 quotationId: number, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getQuotationOffers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetQuotationOffersSuspense<TData = Awaited<ReturnType<typeof getQuotationOffers>>, TError = ErrorType<unknown>>(
 quotationId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getQuotationOffers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetQuotationOffersSuspense<TData = Awaited<ReturnType<typeof getQuotationOffers>>, TError = ErrorType<unknown>>(
 quotationId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getQuotationOffers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get quotation offers tab payload
 */

export function useGetQuotationOffersSuspense<TData = Awaited<ReturnType<typeof getQuotationOffers>>, TError = ErrorType<unknown>>(
 quotationId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getQuotationOffers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetQuotationOffersSuspenseQueryOptions(quotationId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useGetQuotationOffersSuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getQuotationOffers>>>, TError = ErrorType<unknown>>(quotationId: number, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getQuotationOffers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetQuotationOffersInfiniteQueryKey(quotationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getQuotationOffers>>> = ({ signal }) => getQuotationOffers(quotationId, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, ...queryOptions});

   return  customOptions as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getQuotationOffers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetQuotationOffersSuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getQuotationOffers>>>
export type GetQuotationOffersSuspenseInfiniteQueryError = ErrorType<unknown>


export function useGetQuotationOffersSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getQuotationOffers>>>, TError = ErrorType<unknown>>(
 quotationId: number, options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getQuotationOffers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetQuotationOffersSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getQuotationOffers>>>, TError = ErrorType<unknown>>(
 quotationId: number, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getQuotationOffers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetQuotationOffersSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getQuotationOffers>>>, TError = ErrorType<unknown>>(
 quotationId: number, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getQuotationOffers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get quotation offers tab payload
 */

export function useGetQuotationOffersSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getQuotationOffers>>>, TError = ErrorType<unknown>>(
 quotationId: number, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getQuotationOffers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetQuotationOffersSuspenseInfiniteQueryOptions(quotationId,options)

  const query = useSuspenseInfiniteQuery(queryOptions, queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Evaluate offers
 */
export const evaluateQuotationOffers = (
    quotationId: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<EntitiesQuotationMemberOffersCollectionActionResult>(
      {url: `/api/v3/quotations/${quotationId}/offers/evaluate`, method: 'POST', signal
    },
      options);
    }




export const getEvaluateQuotationOffersMutationKey = () => ['evaluateQuotationOffers'] as const;

export const getEvaluateQuotationOffersMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof evaluateQuotationOffers>>, TError,EvaluateQuotationOffersMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof evaluateQuotationOffers>>, TError,EvaluateQuotationOffersMutationVariables, TContext> => {

const mutationKey = getEvaluateQuotationOffersMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof evaluateQuotationOffers>>, EvaluateQuotationOffersMutationVariables> = (props) => {
          const {quotationId} = props ?? {};

          return  evaluateQuotationOffers(quotationId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EvaluateQuotationOffersMutationResult = NonNullable<Awaited<ReturnType<typeof evaluateQuotationOffers>>>

    export type EvaluateQuotationOffersMutationError = ErrorType<unknown>
    export type EvaluateQuotationOffersMutationVariables = {quotationId: number}

    /**
 * @summary Evaluate offers
 */
export const useEvaluateQuotationOffers = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof evaluateQuotationOffers>>, TError,EvaluateQuotationOffersMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof evaluateQuotationOffers>>,
        TError,
        EvaluateQuotationOffersMutationVariables,
        TContext
      > => {
      return useMutation(getEvaluateQuotationOffersMutationOptions(options), queryClient);
    }
    /**
 * @summary Request anticipation evaluation
 */
export const requestAnticipationEvaluation = (
    quotationId: number,
    requestAnticipationEvaluationRequest: RequestAnticipationEvaluationRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<EntitiesQuotationMemberOffersCollectionActionResult>(
      {url: `/api/v3/quotations/${quotationId}/offers/request_anticipation_evaluation`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: requestAnticipationEvaluationRequest, signal
    },
      options);
    }




export const getRequestAnticipationEvaluationMutationKey = () => ['requestAnticipationEvaluation'] as const;

export const getRequestAnticipationEvaluationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestAnticipationEvaluation>>, TError,RequestAnticipationEvaluationMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof requestAnticipationEvaluation>>, TError,RequestAnticipationEvaluationMutationVariables, TContext> => {

const mutationKey = getRequestAnticipationEvaluationMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof requestAnticipationEvaluation>>, RequestAnticipationEvaluationMutationVariables> = (props) => {
          const {quotationId,data} = props ?? {};

          return  requestAnticipationEvaluation(quotationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RequestAnticipationEvaluationMutationResult = NonNullable<Awaited<ReturnType<typeof requestAnticipationEvaluation>>>
    export type RequestAnticipationEvaluationMutationBody = RequestAnticipationEvaluationRequest
    export type RequestAnticipationEvaluationMutationError = ErrorType<unknown>
    export type RequestAnticipationEvaluationMutationVariables = {quotationId: number;data: RequestAnticipationEvaluationRequest}

    /**
 * @summary Request anticipation evaluation
 */
export const useRequestAnticipationEvaluation = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestAnticipationEvaluation>>, TError,RequestAnticipationEvaluationMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof requestAnticipationEvaluation>>,
        TError,
        RequestAnticipationEvaluationMutationVariables,
        TContext
      > => {
      return useMutation(getRequestAnticipationEvaluationMutationOptions(options), queryClient);
    }
    /**
 * @summary Reopen offer window
 */
export const reopenOfferWindow = (
    quotationId: number,
    reopenOfferWindowRequest: ReopenOfferWindowRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<EntitiesQuotationMemberOffersCollectionActionResult>(
      {url: `/api/v3/quotations/${quotationId}/offers/reopen_offer_window`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: reopenOfferWindowRequest, signal
    },
      options);
    }




export const getReopenOfferWindowMutationKey = () => ['reopenOfferWindow'] as const;

export const getReopenOfferWindowMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reopenOfferWindow>>, TError,ReopenOfferWindowMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof reopenOfferWindow>>, TError,ReopenOfferWindowMutationVariables, TContext> => {

const mutationKey = getReopenOfferWindowMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reopenOfferWindow>>, ReopenOfferWindowMutationVariables> = (props) => {
          const {quotationId,data} = props ?? {};

          return  reopenOfferWindow(quotationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReopenOfferWindowMutationResult = NonNullable<Awaited<ReturnType<typeof reopenOfferWindow>>>
    export type ReopenOfferWindowMutationBody = ReopenOfferWindowRequest
    export type ReopenOfferWindowMutationError = ErrorType<unknown>
    export type ReopenOfferWindowMutationVariables = {quotationId: number;data: ReopenOfferWindowRequest}

    /**
 * @summary Reopen offer window
 */
export const useReopenOfferWindow = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reopenOfferWindow>>, TError,ReopenOfferWindowMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof reopenOfferWindow>>,
        TError,
        ReopenOfferWindowMutationVariables,
        TContext
      > => {
      return useMutation(getReopenOfferWindowMutationOptions(options), queryClient);
    }
    /**
 * @summary Open to renegotiation
 */
export const openToRenegotiation = (
    quotationId: number,
    openToRenegotiationRequest: OpenToRenegotiationRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<EntitiesQuotationMemberOffersCollectionActionResult>(
      {url: `/api/v3/quotations/${quotationId}/offers/open_to_renegotiation`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: openToRenegotiationRequest, signal
    },
      options);
    }




export const getOpenToRenegotiationMutationKey = () => ['openToRenegotiation'] as const;

export const getOpenToRenegotiationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof openToRenegotiation>>, TError,OpenToRenegotiationMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof openToRenegotiation>>, TError,OpenToRenegotiationMutationVariables, TContext> => {

const mutationKey = getOpenToRenegotiationMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof openToRenegotiation>>, OpenToRenegotiationMutationVariables> = (props) => {
          const {quotationId,data} = props ?? {};

          return  openToRenegotiation(quotationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type OpenToRenegotiationMutationResult = NonNullable<Awaited<ReturnType<typeof openToRenegotiation>>>
    export type OpenToRenegotiationMutationBody = OpenToRenegotiationRequest
    export type OpenToRenegotiationMutationError = ErrorType<unknown>
    export type OpenToRenegotiationMutationVariables = {quotationId: number;data: OpenToRenegotiationRequest}

    /**
 * @summary Open to renegotiation
 */
export const useOpenToRenegotiation = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof openToRenegotiation>>, TError,OpenToRenegotiationMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof openToRenegotiation>>,
        TError,
        OpenToRenegotiationMutationVariables,
        TContext
      > => {
      return useMutation(getOpenToRenegotiationMutationOptions(options), queryClient);
    }
    /**
 * @summary Close renegotiation
 */
export const closeRenegotiation = (
    quotationId: number,
    closeRenegotiationRequest: CloseRenegotiationRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<EntitiesQuotationMemberOffersCollectionActionResult>(
      {url: `/api/v3/quotations/${quotationId}/offers/close_renegotiation`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: closeRenegotiationRequest, signal
    },
      options);
    }




export const getCloseRenegotiationMutationKey = () => ['closeRenegotiation'] as const;

export const getCloseRenegotiationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof closeRenegotiation>>, TError,CloseRenegotiationMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof closeRenegotiation>>, TError,CloseRenegotiationMutationVariables, TContext> => {

const mutationKey = getCloseRenegotiationMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof closeRenegotiation>>, CloseRenegotiationMutationVariables> = (props) => {
          const {quotationId,data} = props ?? {};

          return  closeRenegotiation(quotationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CloseRenegotiationMutationResult = NonNullable<Awaited<ReturnType<typeof closeRenegotiation>>>
    export type CloseRenegotiationMutationBody = CloseRenegotiationRequest
    export type CloseRenegotiationMutationError = ErrorType<unknown>
    export type CloseRenegotiationMutationVariables = {quotationId: number;data: CloseRenegotiationRequest}

    /**
 * @summary Close renegotiation
 */
export const useCloseRenegotiation = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof closeRenegotiation>>, TError,CloseRenegotiationMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof closeRenegotiation>>,
        TError,
        CloseRenegotiationMutationVariables,
        TContext
      > => {
      return useMutation(getCloseRenegotiationMutationOptions(options), queryClient);
    }
    /**
 * @summary Finish renegotiation
 */
export const finishRenegotiation = (
    quotationId: number,
    finishRenegotiationRequest: FinishRenegotiationRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<EntitiesQuotationMemberOffersCollectionActionResult>(
      {url: `/api/v3/quotations/${quotationId}/offers/finish_renegotiation`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: finishRenegotiationRequest, signal
    },
      options);
    }




export const getFinishRenegotiationMutationKey = () => ['finishRenegotiation'] as const;

export const getFinishRenegotiationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof finishRenegotiation>>, TError,FinishRenegotiationMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof finishRenegotiation>>, TError,FinishRenegotiationMutationVariables, TContext> => {

const mutationKey = getFinishRenegotiationMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof finishRenegotiation>>, FinishRenegotiationMutationVariables> = (props) => {
          const {quotationId,data} = props ?? {};

          return  finishRenegotiation(quotationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type FinishRenegotiationMutationResult = NonNullable<Awaited<ReturnType<typeof finishRenegotiation>>>
    export type FinishRenegotiationMutationBody = FinishRenegotiationRequest
    export type FinishRenegotiationMutationError = ErrorType<unknown>
    export type FinishRenegotiationMutationVariables = {quotationId: number;data: FinishRenegotiationRequest}

    /**
 * @summary Finish renegotiation
 */
export const useFinishRenegotiation = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof finishRenegotiation>>, TError,FinishRenegotiationMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof finishRenegotiation>>,
        TError,
        FinishRenegotiationMutationVariables,
        TContext
      > => {
      return useMutation(getFinishRenegotiationMutationOptions(options), queryClient);
    }
    /**
 * @summary Evaluate offers (legacy path)
 */
export const evaluateQuotationOffersLegacy = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<EntitiesQuotationMemberOffersCollectionActionResult>(
      {url: `/api/v3/quotations/${id}/evaluate_offers`, method: 'POST', signal
    },
      options);
    }




export const getEvaluateQuotationOffersLegacyMutationKey = () => ['evaluateQuotationOffersLegacy'] as const;

export const getEvaluateQuotationOffersLegacyMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof evaluateQuotationOffersLegacy>>, TError,EvaluateQuotationOffersLegacyMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof evaluateQuotationOffersLegacy>>, TError,EvaluateQuotationOffersLegacyMutationVariables, TContext> => {

const mutationKey = getEvaluateQuotationOffersLegacyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof evaluateQuotationOffersLegacy>>, EvaluateQuotationOffersLegacyMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  evaluateQuotationOffersLegacy(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EvaluateQuotationOffersLegacyMutationResult = NonNullable<Awaited<ReturnType<typeof evaluateQuotationOffersLegacy>>>

    export type EvaluateQuotationOffersLegacyMutationError = ErrorType<unknown>
    export type EvaluateQuotationOffersLegacyMutationVariables = {id: number}

    /**
 * @summary Evaluate offers (legacy path)
 */
export const useEvaluateQuotationOffersLegacy = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof evaluateQuotationOffersLegacy>>, TError,EvaluateQuotationOffersLegacyMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof evaluateQuotationOffersLegacy>>,
        TError,
        EvaluateQuotationOffersLegacyMutationVariables,
        TContext
      > => {
      return useMutation(getEvaluateQuotationOffersLegacyMutationOptions(options), queryClient);
    }
    /**
 * @summary Request anticipation evaluation (legacy path)
 */
export const requestAnticipationEvaluationLegacy = (
    id: number,
    requestAnticipationEvaluationLegacyRequest: RequestAnticipationEvaluationLegacyRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<EntitiesQuotationMemberOffersCollectionActionResult>(
      {url: `/api/v3/quotations/${id}/request_anticipation_evaluation`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: requestAnticipationEvaluationLegacyRequest, signal
    },
      options);
    }




export const getRequestAnticipationEvaluationLegacyMutationKey = () => ['requestAnticipationEvaluationLegacy'] as const;

export const getRequestAnticipationEvaluationLegacyMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestAnticipationEvaluationLegacy>>, TError,RequestAnticipationEvaluationLegacyMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof requestAnticipationEvaluationLegacy>>, TError,RequestAnticipationEvaluationLegacyMutationVariables, TContext> => {

const mutationKey = getRequestAnticipationEvaluationLegacyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof requestAnticipationEvaluationLegacy>>, RequestAnticipationEvaluationLegacyMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  requestAnticipationEvaluationLegacy(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RequestAnticipationEvaluationLegacyMutationResult = NonNullable<Awaited<ReturnType<typeof requestAnticipationEvaluationLegacy>>>
    export type RequestAnticipationEvaluationLegacyMutationBody = RequestAnticipationEvaluationLegacyRequest
    export type RequestAnticipationEvaluationLegacyMutationError = ErrorType<unknown>
    export type RequestAnticipationEvaluationLegacyMutationVariables = {id: number;data: RequestAnticipationEvaluationLegacyRequest}

    /**
 * @summary Request anticipation evaluation (legacy path)
 */
export const useRequestAnticipationEvaluationLegacy = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestAnticipationEvaluationLegacy>>, TError,RequestAnticipationEvaluationLegacyMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof requestAnticipationEvaluationLegacy>>,
        TError,
        RequestAnticipationEvaluationLegacyMutationVariables,
        TContext
      > => {
      return useMutation(getRequestAnticipationEvaluationLegacyMutationOptions(options), queryClient);
    }
    /**
 * @summary Reopen offer window (legacy path)
 */
export const reopenOfferWindowLegacy = (
    id: number,
    reopenOfferWindowLegacyRequest: ReopenOfferWindowLegacyRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<EntitiesQuotationMemberOffersCollectionActionResult>(
      {url: `/api/v3/quotations/${id}/reopen_offer_window`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: reopenOfferWindowLegacyRequest, signal
    },
      options);
    }




export const getReopenOfferWindowLegacyMutationKey = () => ['reopenOfferWindowLegacy'] as const;

export const getReopenOfferWindowLegacyMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reopenOfferWindowLegacy>>, TError,ReopenOfferWindowLegacyMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof reopenOfferWindowLegacy>>, TError,ReopenOfferWindowLegacyMutationVariables, TContext> => {

const mutationKey = getReopenOfferWindowLegacyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reopenOfferWindowLegacy>>, ReopenOfferWindowLegacyMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  reopenOfferWindowLegacy(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReopenOfferWindowLegacyMutationResult = NonNullable<Awaited<ReturnType<typeof reopenOfferWindowLegacy>>>
    export type ReopenOfferWindowLegacyMutationBody = ReopenOfferWindowLegacyRequest
    export type ReopenOfferWindowLegacyMutationError = ErrorType<unknown>
    export type ReopenOfferWindowLegacyMutationVariables = {id: number;data: ReopenOfferWindowLegacyRequest}

    /**
 * @summary Reopen offer window (legacy path)
 */
export const useReopenOfferWindowLegacy = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reopenOfferWindowLegacy>>, TError,ReopenOfferWindowLegacyMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof reopenOfferWindowLegacy>>,
        TError,
        ReopenOfferWindowLegacyMutationVariables,
        TContext
      > => {
      return useMutation(getReopenOfferWindowLegacyMutationOptions(options), queryClient);
    }
    /**
 * @summary Open to renegotiation (legacy path)
 */
export const openToRenegotiationLegacy = (
    id: number,
    openToRenegotiationLegacyRequest: OpenToRenegotiationLegacyRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<EntitiesQuotationMemberOffersCollectionActionResult>(
      {url: `/api/v3/quotations/${id}/open_to_renegotiation`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: openToRenegotiationLegacyRequest, signal
    },
      options);
    }




export const getOpenToRenegotiationLegacyMutationKey = () => ['openToRenegotiationLegacy'] as const;

export const getOpenToRenegotiationLegacyMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof openToRenegotiationLegacy>>, TError,OpenToRenegotiationLegacyMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof openToRenegotiationLegacy>>, TError,OpenToRenegotiationLegacyMutationVariables, TContext> => {

const mutationKey = getOpenToRenegotiationLegacyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof openToRenegotiationLegacy>>, OpenToRenegotiationLegacyMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  openToRenegotiationLegacy(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type OpenToRenegotiationLegacyMutationResult = NonNullable<Awaited<ReturnType<typeof openToRenegotiationLegacy>>>
    export type OpenToRenegotiationLegacyMutationBody = OpenToRenegotiationLegacyRequest
    export type OpenToRenegotiationLegacyMutationError = ErrorType<unknown>
    export type OpenToRenegotiationLegacyMutationVariables = {id: number;data: OpenToRenegotiationLegacyRequest}

    /**
 * @summary Open to renegotiation (legacy path)
 */
export const useOpenToRenegotiationLegacy = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof openToRenegotiationLegacy>>, TError,OpenToRenegotiationLegacyMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof openToRenegotiationLegacy>>,
        TError,
        OpenToRenegotiationLegacyMutationVariables,
        TContext
      > => {
      return useMutation(getOpenToRenegotiationLegacyMutationOptions(options), queryClient);
    }
    /**
 * @summary Close renegotiation (legacy path)
 */
export const closeRenegotiationLegacy = (
    id: number,
    closeRenegotiationLegacyRequest: CloseRenegotiationLegacyRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<EntitiesQuotationMemberOffersCollectionActionResult>(
      {url: `/api/v3/quotations/${id}/close_renegotiation`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: closeRenegotiationLegacyRequest, signal
    },
      options);
    }




export const getCloseRenegotiationLegacyMutationKey = () => ['closeRenegotiationLegacy'] as const;

export const getCloseRenegotiationLegacyMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof closeRenegotiationLegacy>>, TError,CloseRenegotiationLegacyMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof closeRenegotiationLegacy>>, TError,CloseRenegotiationLegacyMutationVariables, TContext> => {

const mutationKey = getCloseRenegotiationLegacyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof closeRenegotiationLegacy>>, CloseRenegotiationLegacyMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  closeRenegotiationLegacy(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CloseRenegotiationLegacyMutationResult = NonNullable<Awaited<ReturnType<typeof closeRenegotiationLegacy>>>
    export type CloseRenegotiationLegacyMutationBody = CloseRenegotiationLegacyRequest
    export type CloseRenegotiationLegacyMutationError = ErrorType<unknown>
    export type CloseRenegotiationLegacyMutationVariables = {id: number;data: CloseRenegotiationLegacyRequest}

    /**
 * @summary Close renegotiation (legacy path)
 */
export const useCloseRenegotiationLegacy = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof closeRenegotiationLegacy>>, TError,CloseRenegotiationLegacyMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof closeRenegotiationLegacy>>,
        TError,
        CloseRenegotiationLegacyMutationVariables,
        TContext
      > => {
      return useMutation(getCloseRenegotiationLegacyMutationOptions(options), queryClient);
    }
    /**
 * @summary Finish renegotiation (legacy path)
 */
export const finishRenegotiationLegacy = (
    id: number,
    finishRenegotiationLegacyRequest: FinishRenegotiationLegacyRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<EntitiesQuotationMemberOffersCollectionActionResult>(
      {url: `/api/v3/quotations/${id}/finish_renegotiation`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: finishRenegotiationLegacyRequest, signal
    },
      options);
    }




export const getFinishRenegotiationLegacyMutationKey = () => ['finishRenegotiationLegacy'] as const;

export const getFinishRenegotiationLegacyMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof finishRenegotiationLegacy>>, TError,FinishRenegotiationLegacyMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof finishRenegotiationLegacy>>, TError,FinishRenegotiationLegacyMutationVariables, TContext> => {

const mutationKey = getFinishRenegotiationLegacyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof finishRenegotiationLegacy>>, FinishRenegotiationLegacyMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  finishRenegotiationLegacy(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type FinishRenegotiationLegacyMutationResult = NonNullable<Awaited<ReturnType<typeof finishRenegotiationLegacy>>>
    export type FinishRenegotiationLegacyMutationBody = FinishRenegotiationLegacyRequest
    export type FinishRenegotiationLegacyMutationError = ErrorType<unknown>
    export type FinishRenegotiationLegacyMutationVariables = {id: number;data: FinishRenegotiationLegacyRequest}

    /**
 * @summary Finish renegotiation (legacy path)
 */
export const useFinishRenegotiationLegacy = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof finishRenegotiationLegacy>>, TError,FinishRenegotiationLegacyMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof finishRenegotiationLegacy>>,
        TError,
        FinishRenegotiationLegacyMutationVariables,
        TContext
      > => {
      return useMutation(getFinishRenegotiationLegacyMutationOptions(options), queryClient);
    }
    /**
 * @summary Cancel negotiation
 */
export const cancelNegotiation = (
    quotationId: number,
    negotiationId: number,
    cancelNegotiationRequest: CancelNegotiationRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<EntitiesQuotationMemberOffersMemberActionResult>(
      {url: `/api/v3/quotations/${quotationId}/offers/${negotiationId}/cancel`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: cancelNegotiationRequest, signal
    },
      options);
    }




export const getCancelNegotiationMutationKey = () => ['cancelNegotiation'] as const;

export const getCancelNegotiationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelNegotiation>>, TError,CancelNegotiationMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof cancelNegotiation>>, TError,CancelNegotiationMutationVariables, TContext> => {

const mutationKey = getCancelNegotiationMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelNegotiation>>, CancelNegotiationMutationVariables> = (props) => {
          const {quotationId,negotiationId,data} = props ?? {};

          return  cancelNegotiation(quotationId,negotiationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CancelNegotiationMutationResult = NonNullable<Awaited<ReturnType<typeof cancelNegotiation>>>
    export type CancelNegotiationMutationBody = CancelNegotiationRequest
    export type CancelNegotiationMutationError = ErrorType<unknown>
    export type CancelNegotiationMutationVariables = {quotationId: number;negotiationId: number;data: CancelNegotiationRequest}

    /**
 * @summary Cancel negotiation
 */
export const useCancelNegotiation = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelNegotiation>>, TError,CancelNegotiationMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cancelNegotiation>>,
        TError,
        CancelNegotiationMutationVariables,
        TContext
      > => {
      return useMutation(getCancelNegotiationMutationOptions(options), queryClient);
    }
    /**
 * @summary Award quotation offer
 */
export const awardQuotationOffer = (
    quotationId: number,
    negotiationId: number,
    awardQuotationOfferRequest: AwardQuotationOfferRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<EntitiesQuotationMemberOffersMemberActionResult>(
      {url: `/api/v3/quotations/${quotationId}/offers/${negotiationId}/award`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: awardQuotationOfferRequest, signal
    },
      options);
    }




export const getAwardQuotationOfferMutationKey = () => ['awardQuotationOffer'] as const;

export const getAwardQuotationOfferMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof awardQuotationOffer>>, TError,AwardQuotationOfferMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof awardQuotationOffer>>, TError,AwardQuotationOfferMutationVariables, TContext> => {

const mutationKey = getAwardQuotationOfferMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof awardQuotationOffer>>, AwardQuotationOfferMutationVariables> = (props) => {
          const {quotationId,negotiationId,data} = props ?? {};

          return  awardQuotationOffer(quotationId,negotiationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AwardQuotationOfferMutationResult = NonNullable<Awaited<ReturnType<typeof awardQuotationOffer>>>
    export type AwardQuotationOfferMutationBody = AwardQuotationOfferRequest
    export type AwardQuotationOfferMutationError = ErrorType<unknown>
    export type AwardQuotationOfferMutationVariables = {quotationId: number;negotiationId: number;data: AwardQuotationOfferRequest}

    /**
 * @summary Award quotation offer
 */
export const useAwardQuotationOffer = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof awardQuotationOffer>>, TError,AwardQuotationOfferMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof awardQuotationOffer>>,
        TError,
        AwardQuotationOfferMutationVariables,
        TContext
      > => {
      return useMutation(getAwardQuotationOfferMutationOptions(options), queryClient);
    }
    /**
 * @summary Cancel negotiation (legacy path)
 */
export const cancelNegotiationLegacy = (
    id: number,
    cancelNegotiationLegacyRequest: CancelNegotiationLegacyRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<EntitiesQuotationMemberOffersMemberActionResult>(
      {url: `/api/v3/quotations/${id}/cancel_negotiation`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: cancelNegotiationLegacyRequest, signal
    },
      options);
    }




export const getCancelNegotiationLegacyMutationKey = () => ['cancelNegotiationLegacy'] as const;

export const getCancelNegotiationLegacyMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelNegotiationLegacy>>, TError,CancelNegotiationLegacyMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof cancelNegotiationLegacy>>, TError,CancelNegotiationLegacyMutationVariables, TContext> => {

const mutationKey = getCancelNegotiationLegacyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelNegotiationLegacy>>, CancelNegotiationLegacyMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  cancelNegotiationLegacy(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CancelNegotiationLegacyMutationResult = NonNullable<Awaited<ReturnType<typeof cancelNegotiationLegacy>>>
    export type CancelNegotiationLegacyMutationBody = CancelNegotiationLegacyRequest
    export type CancelNegotiationLegacyMutationError = ErrorType<unknown>
    export type CancelNegotiationLegacyMutationVariables = {id: number;data: CancelNegotiationLegacyRequest}

    /**
 * @summary Cancel negotiation (legacy path)
 */
export const useCancelNegotiationLegacy = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelNegotiationLegacy>>, TError,CancelNegotiationLegacyMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cancelNegotiationLegacy>>,
        TError,
        CancelNegotiationLegacyMutationVariables,
        TContext
      > => {
      return useMutation(getCancelNegotiationLegacyMutationOptions(options), queryClient);
    }
    /**
 * @summary Search vendors for quotation
 */
export const searchQuotationVendors = (
    id: number,
    params: SearchQuotationVendorsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<EntitiesQuotationMemberSearchVendorsListResponse>(
      {url: `/api/v3/quotations/${id}/search_vendors`, method: 'GET',
        params, signal
    },
      options);
    }




export const getSearchQuotationVendorsInfiniteQueryKey = (id: number,
    params?: SearchQuotationVendorsParams,) => {
    return [
    'infinite', `/api/v3/quotations/${id}/search_vendors`, ...(params ? [params] : [])
    ] as const;
    }

export const getSearchQuotationVendorsQueryKey = (id: number,
    params?: SearchQuotationVendorsParams,) => {
    return [
    `/api/v3/quotations/${id}/search_vendors`, ...(params ? [params] : [])
    ] as const;
    }


export const useSearchQuotationVendorsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof searchQuotationVendors>>>, TError = ErrorType<unknown>>(id: number,
    params: SearchQuotationVendorsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof searchQuotationVendors>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSearchQuotationVendorsInfiniteQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchQuotationVendors>>> = ({ signal }) => searchQuotationVendors(id,params, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions});

   return  customOptions as UseInfiniteQueryOptions<Awaited<ReturnType<typeof searchQuotationVendors>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SearchQuotationVendorsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof searchQuotationVendors>>>
export type SearchQuotationVendorsInfiniteQueryError = ErrorType<unknown>


export function useSearchQuotationVendorsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof searchQuotationVendors>>>, TError = ErrorType<unknown>>(
 id: number,
    params: SearchQuotationVendorsParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof searchQuotationVendors>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchQuotationVendors>>,
          TError,
          Awaited<ReturnType<typeof searchQuotationVendors>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSearchQuotationVendorsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof searchQuotationVendors>>>, TError = ErrorType<unknown>>(
 id: number,
    params: SearchQuotationVendorsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof searchQuotationVendors>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchQuotationVendors>>,
          TError,
          Awaited<ReturnType<typeof searchQuotationVendors>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSearchQuotationVendorsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof searchQuotationVendors>>>, TError = ErrorType<unknown>>(
 id: number,
    params: SearchQuotationVendorsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof searchQuotationVendors>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Search vendors for quotation
 */

export function useSearchQuotationVendorsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof searchQuotationVendors>>>, TError = ErrorType<unknown>>(
 id: number,
    params: SearchQuotationVendorsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof searchQuotationVendors>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useSearchQuotationVendorsInfiniteQueryOptions(id,params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Search vendors for quotation
 */
export const prefetchSearchQuotationVendorsInfiniteQuery = async <TData = Awaited<ReturnType<typeof searchQuotationVendors>>, TError = ErrorType<unknown>>(
 queryClient: QueryClient, id: number,
    params: SearchQuotationVendorsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof searchQuotationVendors>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = useSearchQuotationVendorsInfiniteQueryOptions(id,params,options)

  await queryClient.infiniteQuery(queryOptions).catch(() => {});

  return queryClient;
}

/**
 * @summary Invalidates the {@link useSearchQuotationVendorsInfinite} query
 */
export const invalidateSearchQuotationVendorsInfinite = async (
 queryClient: QueryClient, id: number,
    params: SearchQuotationVendorsParams, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: customQueryOptions({ queryKey: getSearchQuotationVendorsInfiniteQueryKey(id,params) }).queryKey }, options);

  return queryClient;
}




export const useSearchQuotationVendorsQueryOptions = <TData = Awaited<ReturnType<typeof searchQuotationVendors>>, TError = ErrorType<unknown>>(id: number,
    params: SearchQuotationVendorsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchQuotationVendors>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSearchQuotationVendorsQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchQuotationVendors>>> = ({ signal }) => searchQuotationVendors(id,params, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof searchQuotationVendors>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SearchQuotationVendorsQueryResult = NonNullable<Awaited<ReturnType<typeof searchQuotationVendors>>>
export type SearchQuotationVendorsQueryError = ErrorType<unknown>


export function useSearchQuotationVendors<TData = Awaited<ReturnType<typeof searchQuotationVendors>>, TError = ErrorType<unknown>>(
 id: number,
    params: SearchQuotationVendorsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchQuotationVendors>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchQuotationVendors>>,
          TError,
          Awaited<ReturnType<typeof searchQuotationVendors>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSearchQuotationVendors<TData = Awaited<ReturnType<typeof searchQuotationVendors>>, TError = ErrorType<unknown>>(
 id: number,
    params: SearchQuotationVendorsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchQuotationVendors>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchQuotationVendors>>,
          TError,
          Awaited<ReturnType<typeof searchQuotationVendors>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSearchQuotationVendors<TData = Awaited<ReturnType<typeof searchQuotationVendors>>, TError = ErrorType<unknown>>(
 id: number,
    params: SearchQuotationVendorsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchQuotationVendors>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Search vendors for quotation
 */

export function useSearchQuotationVendors<TData = Awaited<ReturnType<typeof searchQuotationVendors>>, TError = ErrorType<unknown>>(
 id: number,
    params: SearchQuotationVendorsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchQuotationVendors>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useSearchQuotationVendorsQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Search vendors for quotation
 */
export const prefetchSearchQuotationVendorsQuery = async <TData = Awaited<ReturnType<typeof searchQuotationVendors>>, TError = ErrorType<unknown>>(
 queryClient: QueryClient, id: number,
    params: SearchQuotationVendorsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchQuotationVendors>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = useSearchQuotationVendorsQueryOptions(id,params,options)

  await queryClient.query(queryOptions).catch(() => {});

  return queryClient;
}

/**
 * @summary Invalidates the {@link useSearchQuotationVendors} query
 */
export const invalidateSearchQuotationVendors = async (
 queryClient: QueryClient, id: number,
    params: SearchQuotationVendorsParams, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: customQueryOptions({ queryKey: getSearchQuotationVendorsQueryKey(id,params) }).queryKey }, options);

  return queryClient;
}




export const useSearchQuotationVendorsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof searchQuotationVendors>>, TError = ErrorType<unknown>>(id: number,
    params: SearchQuotationVendorsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof searchQuotationVendors>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSearchQuotationVendorsQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchQuotationVendors>>> = ({ signal }) => searchQuotationVendors(id,params, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, ...queryOptions});

   return  customOptions as UseSuspenseQueryOptions<Awaited<ReturnType<typeof searchQuotationVendors>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SearchQuotationVendorsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof searchQuotationVendors>>>
export type SearchQuotationVendorsSuspenseQueryError = ErrorType<unknown>


export function useSearchQuotationVendorsSuspense<TData = Awaited<ReturnType<typeof searchQuotationVendors>>, TError = ErrorType<unknown>>(
 id: number,
    params: SearchQuotationVendorsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof searchQuotationVendors>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSearchQuotationVendorsSuspense<TData = Awaited<ReturnType<typeof searchQuotationVendors>>, TError = ErrorType<unknown>>(
 id: number,
    params: SearchQuotationVendorsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof searchQuotationVendors>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSearchQuotationVendorsSuspense<TData = Awaited<ReturnType<typeof searchQuotationVendors>>, TError = ErrorType<unknown>>(
 id: number,
    params: SearchQuotationVendorsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof searchQuotationVendors>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Search vendors for quotation
 */

export function useSearchQuotationVendorsSuspense<TData = Awaited<ReturnType<typeof searchQuotationVendors>>, TError = ErrorType<unknown>>(
 id: number,
    params: SearchQuotationVendorsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof searchQuotationVendors>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useSearchQuotationVendorsSuspenseQueryOptions(id,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useSearchQuotationVendorsSuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof searchQuotationVendors>>>, TError = ErrorType<unknown>>(id: number,
    params: SearchQuotationVendorsParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof searchQuotationVendors>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSearchQuotationVendorsInfiniteQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchQuotationVendors>>> = ({ signal }) => searchQuotationVendors(id,params, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, ...queryOptions});

   return  customOptions as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof searchQuotationVendors>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SearchQuotationVendorsSuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof searchQuotationVendors>>>
export type SearchQuotationVendorsSuspenseInfiniteQueryError = ErrorType<unknown>


export function useSearchQuotationVendorsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof searchQuotationVendors>>>, TError = ErrorType<unknown>>(
 id: number,
    params: SearchQuotationVendorsParams, options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof searchQuotationVendors>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSearchQuotationVendorsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof searchQuotationVendors>>>, TError = ErrorType<unknown>>(
 id: number,
    params: SearchQuotationVendorsParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof searchQuotationVendors>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSearchQuotationVendorsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof searchQuotationVendors>>>, TError = ErrorType<unknown>>(
 id: number,
    params: SearchQuotationVendorsParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof searchQuotationVendors>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Search vendors for quotation
 */

export function useSearchQuotationVendorsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof searchQuotationVendors>>>, TError = ErrorType<unknown>>(
 id: number,
    params: SearchQuotationVendorsParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof searchQuotationVendors>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useSearchQuotationVendorsSuspenseInfiniteQueryOptions(id,params,options)

  const query = useSuspenseInfiniteQuery(queryOptions, queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






